(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Tab') {
      document.documentElement.classList.add('keyboard-navigation');
    }
  }, true);

  document.addEventListener('pointerdown', () => {
    document.documentElement.classList.remove('keyboard-navigation');
  }, true);

  const money = (cents) => {
    const minorUnits = Number(cents) || 0;
    const hasFraction = Math.abs(minorUnits) % 100 !== 0;
    const fractionDigits = hasFraction ? 2 : 0;

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(minorUnits / 100);
  };
  const unlockKey = 'inlet-freebies-unlocked';
  const storefrontRoot = window.Inlet?.routes?.root || '/';

  const earlyAccessDataNode =
    $('#InletEarlyAccessData');

  let earlyAccess = {
    state: 'none',
    unlocked: false
  };

  if (earlyAccessDataNode) {
    try {
      const data = JSON.parse(
        earlyAccessDataNode.textContent
      );

      if (data.product?.id && data.endUnix) {
        const now = Date.now();
        const start =
          Number(data.startUnix) * 1000;
        const end =
          Number(data.endUnix) * 1000;

        let state = 'ended';

        if (now < start) {
          state = 'pre';
        } else if (now < end) {
          state = 'active';
        }

        const browserUnlockKey =
          `inlet-ea-unlocked-${data.product.id}-${data.endUnix}`;

        let unlocked = false;

        try {
          unlocked =
            state === 'active' &&
            localStorage.getItem(
              browserUnlockKey
            ) === 'true';
        } catch (error) {
          unlocked = false;
        }

        earlyAccess = {
          ...data,
          state,
          unlocked,
          browserUnlockKey
        };
      }
    } catch (error) {
      console.warn(
        'Unable to read Early Access campaign.',
        error
      );
    }
  }

  window.Inlet = window.Inlet || {};
  window.Inlet.earlyAccess = earlyAccess;

  const scheduleEarlyAccessBoundaryReload = () => {
    if (!earlyAccess.product?.id) return;

    const boundaryUnix =
      earlyAccess.state === 'pre'
        ? Number(earlyAccess.startUnix)
        : earlyAccess.state === 'active'
          ? Number(earlyAccess.endUnix)
          : 0;

    if (!boundaryUnix) return;

    const delay =
      boundaryUnix * 1000 - Date.now();

    if (delay <= 0) return;

    window.setTimeout(
      () => {
        window.location.reload();
      },
      Math.min(
        delay + 250,
        2147483000
      )
    );
  };

  scheduleEarlyAccessBoundaryReload();

  const applyEarlyAccessCards = () => {
  if (
    earlyAccess.state !== 'active' ||
    !earlyAccess.product?.id
  ) {
    return;
  }

  $$('[data-product-card]').forEach((card) => {
    if (
      String(card.dataset.productId) !==
      String(earlyAccess.product.id)
    ) {
      return;
    }

    card.classList.add('is-early-access');

const libraryGrid = card.closest(
  '[data-product-grid="libraries"]'
);

if (libraryGrid) {
  libraryGrid.prepend(card);
}

const imageWrap = $('.image-wrap', card);

    if (!imageWrap) return;

    let badge = $('.product-badge', imageWrap);

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'product-badge';
      imageWrap.appendChild(badge);
    }

    badge.classList.add('early-access-card-badge');
    badge.textContent = 'early access';
  });
};

applyEarlyAccessCards();

const formatEarlyAccessTime = (endUnix) => {
  const remaining =
    Number(endUnix) * 1000 - Date.now();

  if (remaining <= 0) return '';

  const totalHours =
    Math.floor(remaining / (1000 * 60 * 60));

  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  if (days > 0 && hours > 0) {
    return `${days} ${days === 1 ? 'day' : 'days'} ${hours} ${
      hours === 1 ? 'hour' : 'hours'
    } left`;
  }

  if (days > 0) {
    return `${days} ${days === 1 ? 'day' : 'days'} left`;
  }

  if (totalHours >= 1) {
    return `${totalHours} ${
      totalHours === 1 ? 'hour' : 'hours'
    } left`;
  }

  return 'less than 1 hour left';
};

const applyEarlyAccessCartLines = () => {
  if (
    earlyAccess.state !== 'active' ||
    !earlyAccess.product?.id
  ) {
    return;
  }

  $$(
    '.inlet-bag-line[data-product-id]'
  ).forEach((line) => {
    if (
      String(line.dataset.productId) !==
      String(earlyAccess.product.id)
    ) {
      return;
    }

    const copy =
      $('.inlet-bag-line__copy > div:first-child', line);

    if (copy) {
      let status =
        $('.inlet-bag-line__ea-status', line);

      if (!status) {
        status =
          document.createElement('p');

        status.className =
          'inlet-bag-line__ea-status';

        copy.appendChild(status);
      }

      status.textContent =
        `early access · ${formatEarlyAccessTime(
          earlyAccess.endUnix
        )}`;
    }

    const price =
      $('.inlet-bag-line__price', line);

    const quantity =
      Number(
        $('[data-cart-quantity]', line)?.value
      ) || 1;

    if (
      price &&
      Number(
        earlyAccess.product.compareAtPrice
      ) >
      Number(
        earlyAccess.product.price
      )
    ) {
      let compare =
        $('.inlet-bag-line__ea-compare', price);

      if (!compare) {
        compare =
          document.createElement('s');

        compare.className =
          'inlet-bag-line__ea-compare';

        price.prepend(compare);
      }

      compare.textContent =
        money(
          Number(
            earlyAccess.product.compareAtPrice
          ) * quantity
        );
    }
  });
};

const renderEarlyAccessShopFeature = () => {
  const feature = $('[data-ea-shop-feature]');

  if (!feature) return;

  const shouldShow =
    earlyAccess.state === 'active' &&
    earlyAccess.shopFeaturedModule === true &&
    earlyAccess.product?.id;

  feature.hidden = !shouldShow;

  if (!shouldShow) {
    feature.replaceChildren();
    return;
  }

  const timeRemaining =
    formatEarlyAccessTime(earlyAccess.endUnix);

  feature.innerHTML = `
    <div class="ea-shop-feature-visual">
      <img alt="" hidden>
    </div>

    <a
      class="ea-shop-feature-link"
      href="#"
    ></a>

    <div class="ea-shop-feature-content">
      <div class="ea-shop-feature-copy">
        <div class="pdp-ea-status">
          <span>early access</span>
          <span aria-hidden="true">·</span>
          <strong></strong>
        </div>

        <strong class="ea-shop-feature-heading"></strong>
        <span class="ea-shop-feature-meta"></span>
      </div>

      <div class="ea-shop-feature-bottom">
        <div class="pdp-ea-price-row">
          <s hidden></s>
          <strong></strong>
          <em></em>
        </div>

        <button
          class="ea-shop-feature-action"
          type="button"
        >
          quick view
        </button>
      </div>
    </div>
  `;

  const image = $('img', feature);

  if (earlyAccess.shopImage) {
    image.src = earlyAccess.shopImage;
    image.hidden = false;
  }

  const productCard =
    document.querySelector(
      `[data-product-card][data-product-id="${earlyAccess.product.id}"]`
    );

  const quickView =
    productCard
      ? $('[data-quick-view]', productCard)
      : null;

  const quickViewTemplate =
    quickView?.dataset.quickView
      ? document.getElementById(
          quickView.dataset.quickView
        )
      : null;

  const productData =
    quickViewTemplate?.content
      ?.firstElementChild
      ?.dataset;

  if (productData?.soft) {
    feature.style.setProperty(
      '--ea-soft',
      productData.soft
    );
  }

  if (productData?.deep) {
    feature.style.setProperty(
      '--ea-deep',
      productData.deep
    );
  }

  const productLink =
    $('.ea-shop-feature-link', feature);

  productLink.href =
    earlyAccess.product.url || '#';

  productLink.setAttribute(
    'aria-label',
    `View full ${earlyAccess.product.title} product page`
  );

  $('.pdp-ea-status > strong', feature)
    .textContent = timeRemaining;

  $('.ea-shop-feature-heading', feature)
    .textContent =
      earlyAccess.product.title;

  $('.ea-shop-feature-meta', feature)
    .textContent =
      earlyAccess.product.descriptor || '';

  $('.pdp-ea-price-row > strong', feature)
    .textContent =
      money(earlyAccess.product.price);

  $('.pdp-ea-price-row > em', feature)
    .textContent =
      `save ${earlyAccess.savingPercentage}%`;

  const compare =
    $('.pdp-ea-price-row > s', feature);

  if (
    Number(earlyAccess.product.compareAtPrice) >
    Number(earlyAccess.product.price)
  ) {
    compare.textContent =
      money(earlyAccess.product.compareAtPrice);

    compare.hidden = false;
  }

  const action =
    $('.ea-shop-feature-action', feature);

  action.setAttribute(
    'aria-label',
    `Quick view ${earlyAccess.product.title}`
  );

  action.addEventListener('click', () => {
    const quickView =
      document.querySelector(
        `[data-product-card][data-product-id="${earlyAccess.product.id}"] [data-quick-view]`
      );

    if (quickView) {
      quickView._inletReturnFocus = action;
      quickView.click();
    } else if (earlyAccess.product.url) {
      window.location.href =
        earlyAccess.product.url;
    }
  });
};

renderEarlyAccessShopFeature();
applyEarlyAccessCartLines();

const applyEarlyAccessHomeHero = () => {
  const homePage = $('.home-page');

  if (
    !homePage ||
    earlyAccess.state !== 'active' ||
    earlyAccess.homepageLaunchTreatment !== true ||
    !earlyAccess.product?.id
  ) {
    return;
  }

  const heroArt =
    $('.home-hero-art', homePage);

  if (!heroArt) return;

  const primaryFrame =
    $('.home-art-main', heroArt);

  const primaryImage =
    $('.home-art-main img', heroArt);

  const secondaryFrame =
    $('.home-art-secondary', heroArt);

  const heroLink =
    $('.home-art-hit-main', heroArt);

  const label =
    $('.home-art-label', heroArt);

  const caption =
    $('.home-art-caption', heroArt);

  const captionTitle =
    $('.home-art-caption strong', heroArt);

  const captionDescriptor =
    $('.home-art-caption small', heroArt);

  const captionPrice =
    $('.home-art-caption > span:last-child', heroArt);

  heroArt.classList.add(
    'is-early-access-home-hero'
  );

  if (
    primaryFrame &&
    primaryImage &&
    earlyAccess.homepageImage
  ) {
    primaryImage.removeAttribute(
      'srcset'
    );

    primaryImage.removeAttribute(
      'sizes'
    );

    primaryImage.src =
      earlyAccess.homepageImage;

    primaryImage.alt =
      `${earlyAccess.product.title} interface`;

    primaryFrame.hidden = false;
  }

  if (secondaryFrame) {
    secondaryFrame.hidden = true;
  }

  if (heroLink) {
    heroLink.href =
      earlyAccess.product.url;

    heroLink.setAttribute(
      'aria-label',
      `Explore ${earlyAccess.product.title}`
    );
  }

  if (label) {
    label.textContent =
      `early access · ${formatEarlyAccessTime(
        earlyAccess.endUnix
      )}`;
  }

  if (caption) {
    caption.href =
      earlyAccess.product.url;

    caption.setAttribute(
      'aria-label',
      `Explore ${earlyAccess.product.title}`
    );
  }

  if (captionTitle) {
    captionTitle.textContent =
      earlyAccess.product.title;
  }

  if (captionDescriptor) {
    captionDescriptor.textContent =
      earlyAccess.product.descriptor || '';
  }

  if (captionPrice) {
    const arrow =
      $('.inline-arrow', captionPrice);

    const arrowMarkup =
      arrow?.outerHTML || '';

    const hasComparePrice =
      Number(
        earlyAccess.product.compareAtPrice
      ) >
      Number(
        earlyAccess.product.price
      );

    captionPrice.innerHTML =
      `${
        hasComparePrice
          ? `<s>${money(
              earlyAccess.product.compareAtPrice
            )}</s>`
          : ''
      }
      <strong>${money(
        earlyAccess.product.price
      )}</strong>
      ${
        hasComparePrice
          ? `<em>save ${earlyAccess.savingPercentage}%</em>`
          : ''
      }
      ${arrowMarkup}`;
  }
};

applyEarlyAccessHomeHero();

  const cartEndpoint = `${storefrontRoot}cart.js`;
const addEndpoint = `${storefrontRoot}cart/add.js`;
let lastFocus = null;
let cartSnapshot = null;

const getCartQuantity = (variantId, cart = cartSnapshot) => {
  if (!cart?.items) return 0;

  return cart.items.reduce((total, item) => {
    const itemVariantId = Number(item.variant_id || item.id);

    return itemVariantId === Number(variantId)
      ? total + (Number(item.quantity) || 0)
      : total;
  }, 0);
};

const updateCount = async () => {
  const response = await fetch(cartEndpoint, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to update the bag count. Please refresh and try again.');
  const cart = await response.json();
  cartSnapshot = cart;
  $$('[data-cart-count]').forEach((node) => { node.textContent = `(${cart.item_count})`; });
  $$('[data-cart-link]').forEach((link) => {
    link.setAttribute('aria-label', `Shopping bag with ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`);
  });
  return cart;
};

const addItems = async (items) => {
  const cart = await updateCount();
  const occupiedVariantIds = new Set(
    (cart.items || []).map((item) =>
      Number(item.variant_id || item.id)
    )
  );

  const itemsToAdd = items.filter((item) => {
    const variantId = Number(item.id);

    if (occupiedVariantIds.has(variantId)) return false;

    occupiedVariantIds.add(variantId);
    return true;
  });

  if (!itemsToAdd.length) {
    return {
      alreadyInBag: true,
      cart
    };
  }

  const response = await fetch(addEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items: itemsToAdd })
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      result.description ||
      result.message ||
      'Unable to add this item. Please try again.'
    );
  }

  const updatedCart = await updateCount();

  return {
    alreadyInBag: false,
    cart: updatedCart,
    result
  };
};
  const openLayer = (layer, trigger) => {
    lastFocus = trigger || document.activeElement;
    layer.hidden = false;
    document.body.classList.add('overlay-open');
    requestAnimationFrame(() => ($('button, [href], input, select, textarea', layer) || layer).focus());
  };
  const closeLayer = (layer) => {
    layer.hidden = true;
    document.body.classList.remove('overlay-open');
    if (lastFocus?.focus) lastFocus.focus();
  };
  const trap = (event, layer) => {
    if (event.key === 'Escape') return closeLayer(layer);
    if (event.key !== 'Tab') return;
    const focusable = $$('button:not([disabled]), [href], input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', layer).filter((node) => !node.hidden);
    if (!focusable.length) return;
    const first = focusable[0]; const last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

    const searchPanel = $('[data-search-panel]');
  const searchToggle = $('[data-search-toggle]');
  const searchInput = $('[data-search-input]');
  const searchClear = $('[data-search-clear]');

  const updateSearchClear = () => {
    if (searchClear) searchClear.hidden = !searchInput?.value.trim();
  };

  const setSearch = (open) => {
  if (!searchPanel) return;

  searchPanel.hidden = !open;

  searchToggle?.setAttribute(
    'aria-expanded',
    String(open)
  );

  if (open) {
    updateSearchClear();

    requestAnimationFrame(() => {
      searchInput?.focus();

      const shopViews = $('#shop-views');

      if (!shopViews) return;

      const panelRect =
        searchPanel.getBoundingClientRect();

      const viewsRect =
        shopViews.getBoundingClientRect();

      const desiredTop =
        panelRect.bottom + 18;

      if (viewsRect.top < desiredTop) {
        window.scrollBy({
          top: viewsRect.top - desiredTop,
          behavior: 'smooth'
        });
      }
    });
  } else if (searchPanel.contains(document.activeElement)) {
    searchToggle?.focus();
  }
};

  searchToggle?.addEventListener('click', () => setSearch(searchPanel.hidden));

document.addEventListener('pointerdown', (event) => {
  if (
    searchPanel &&
    !searchPanel.hidden &&
    !searchPanel.contains(event.target) &&
    !searchToggle?.contains(event.target)
  ) {
    setSearch(false);
  }
});
  $('[data-search-close]')?.addEventListener('click', () => setSearch(false));
  searchInput?.addEventListener('input', updateSearchClear);
  searchClear?.addEventListener('click', () => { searchInput.value = ''; searchInput.dispatchEvent(new Event('input')); searchInput.focus(); });

  const footerSignupForm = $('#FooterSignupForm');

  if (footerSignupForm) {
    const footerSignupPendingKey =
      'inlet-footer-signup-pending';

    const showFooterSignupSuccess = () => {
      footerSignupForm.innerHTML = `
        <p class="footer-signup-success" role="status">
          you're in. welcome to inlet.
        </p>
      `;
    };

    const existingSuccess = $(
      '.footer-signup-success',
      footerSignupForm
    );

    const existingErrors = $(
      '.footer-signup-errors',
      footerSignupForm
    );

    if (existingSuccess) {
      sessionStorage.removeItem(
        footerSignupPendingKey
      );
    } else if (existingErrors) {
      sessionStorage.removeItem(
        footerSignupPendingKey
      );
    } else if (
      location.hash === '#FooterSignupForm' &&
      sessionStorage.getItem(
        footerSignupPendingKey
      ) === 'true'
    ) {
      sessionStorage.removeItem(
        footerSignupPendingKey
      );

      showFooterSignupSuccess();
    }

    footerSignupForm.addEventListener(
      'submit',
      () => {
        sessionStorage.setItem(
          footerSignupPendingKey,
          'true'
        );
      }
    );
  }

  const productForms = $$('form.product-form');

productForms.forEach((form) => {
  const button = $('button[type="submit"]', form);

  if (!button) return;

  const label = $('span', button);

  button.dataset.originalDisabled = String(button.disabled);
  button.dataset.defaultLabel = label?.textContent || 'add to bag';

  const showInBagAction = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'view bag';
  };

  const showInBagStatus = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'already in bag';
  };

  button.addEventListener('mouseenter', showInBagAction);
  button.addEventListener('mouseleave', showInBagStatus);
  button.addEventListener('focus', showInBagAction);
  button.addEventListener('blur', showInBagStatus);
});

const setProductButtons = (label, disabled = false) => {
  productForms.forEach((form) => {
    const button = $('button[type="submit"]', form);

    if (!button) return;

    const text = $('span', button);

    if (text) text.textContent = label;
    button.disabled = disabled;
  });
};

const syncProductFormsWithCart = (cart) => {
  productForms.forEach((form) => {
    const button = $('button[type="submit"]', form);

    if (!button) return;

    const text = $('span', button);
    const variantId = Number(
      $('input[name="id"]', form)?.value
    );
    const viewBag = $('[data-product-view-bag]', form);

    if (!variantId) return;

    const inBag = getCartQuantity(variantId, cart) > 0;

    if (inBag) {
      if (text) text.textContent = 'already in bag';
      button.dataset.inBag = 'true';
      button.disabled = false;
      button.setAttribute(
        'aria-label',
        'Already in bag. View bag'
      );
      if (viewBag) viewBag.hidden = false;
      return;
    }

    if (text) {
      text.textContent = button.dataset.defaultLabel;
    }

    button.dataset.inBag = 'false';
    button.removeAttribute('aria-label');

    button.disabled =
      button.dataset.originalDisabled === 'true';

    if (viewBag) viewBag.hidden = true;
  });
};

productForms.forEach((form) => form.addEventListener('submit', async (event) => {
  event.preventDefault(); const button = $('button[type="submit"]', form); const status = $('.product-form-status', form);

  if (button.dataset.inBag === 'true') {
    window.location.href = `${storefrontRoot}cart`;
    return;
  }

  button.disabled = true; if (status) status.hidden = true;
  try {
const variantId = Number(new FormData(form).get('id'));
const result = await addItems([
  {
    id: variantId,
    quantity: 1
  }
]);

if (result?.alreadyInBag) {
  productForms.forEach((form) => {
    const productButton = $('button[type="submit"]', form);

    if (productButton) {
      productButton.dataset.inBag = 'true';
      productButton.setAttribute(
        'aria-label',
        'Already in bag. View bag'
      );
    }
  });
}

setProductButtons(
  result?.alreadyInBag
    ? 'already in bag'
    : 'yay, added to bag',
  !result?.alreadyInBag
);

$$('[data-product-view-bag]').forEach((link) => {
  link.hidden = false;
});
}
  catch (error) { if (status) { status.textContent = error.message; status.hidden = false; } else button.setAttribute('aria-label', error.message); setProductButtons('add to bag', false); }
}));

if (productForms.length) {
  const refreshProductFormState = () => {
    updateCount()
      .then(syncProductFormsWithCart)
      .catch(() => {});
  };

  refreshProductFormState();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshProductFormState();
  });
}
    const cartForm = $('[data-cart-form]');

  if (cartForm) {
    let cartUpdateTimer = null;

    const updateStatus = $(
      '[data-cart-update-status]',
      cartForm
    );

    const consent = $(
      '[data-checkout-consent]',
      cartForm
    );

    const checkoutButton = $(
      '[data-checkout-button]',
      cartForm
    );

    const checkoutLabel = $(
      '[data-checkout-button-label]',
      cartForm
    );

    const consentStatus = $(
      '[data-checkout-consent-status]',
      cartForm
    );

    const syncQuantityControl = (input) => {
  const control = input.closest(
    '[data-cart-quantity-control]'
  );
  const decrease = $(
    '[data-cart-quantity-step="-1"]',
    control
  );
  const value = Math.max(
    1,
    Number.parseInt(input.value, 10) || 1
  );

  if (decrease) decrease.disabled = value <= 1;
};

const scheduleCartUpdate = (input) => {
  clearTimeout(cartUpdateTimer);
  syncQuantityControl(input);

  if (updateStatus) {
    updateStatus.textContent = 'Updating bag…';
    updateStatus.hidden = false;
  }

  cartUpdateTimer = setTimeout(() => {
    cartForm.requestSubmit();
  }, 700);
};

$$('[data-cart-quantity]', cartForm).forEach(
  (input) => {
    syncQuantityControl(input);

    input.addEventListener('input', () => {
      scheduleCartUpdate(input);
    });
  }
);

$$('[data-cart-quantity-step]', cartForm).forEach(
  (button) => {
    button.addEventListener('click', () => {
      const control = button.closest(
        '[data-cart-quantity-control]'
      );
      const input = $('[data-cart-quantity]', control);

      if (!input) return;

      const current = Math.max(
        1,
        Number.parseInt(input.value, 10) || 1
      );
      const delta = Number(button.dataset.cartQuantityStep);
      const next = Math.max(1, current + delta);

      if (next === current) return;

      input.value = String(next);
      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    });
  }
);

    cartForm.addEventListener('submit', async (event) => {
      clearTimeout(cartUpdateTimer);

      const isCheckout =
        event.submitter?.name === 'checkout';

      if (!isCheckout) return;

      event.preventDefault();

      if (!consent?.checked) {
  if (consentStatus) {
    consentStatus.textContent =
      'Tick the box to continue to checkout.';
    consentStatus.hidden = false;
  }

  consent?.focus();
  return;
}

if (consentStatus) {
  consentStatus.textContent = '';
  consentStatus.hidden = true;
}

      const timestamp = new Date().toISOString();

      const consentText =
        'Customer expressly consented to immediate digital delivery before the end of the 14-day withdrawal period and acknowledged that the statutory right of withdrawal is lost once delivery begins.';

      checkoutButton.disabled = true;

      if (checkoutLabel) {
        checkoutLabel.textContent = 'one moment…';
      }

      if (consentStatus) {
        consentStatus.hidden = true;
        consentStatus.textContent = '';
      }

      try {
        const response = await fetch(
          `${storefrontRoot}cart/update.js`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                'Checkout Consent': consentText,
                'Checkout Consent Timestamp (UTC)':
                  timestamp,
                'Checkout Consent Version': 'v2'
              }
            })
          }
        );

        const cart = await response.json();

        const consentSaved =
          response.ok &&
          cart.attributes?.['Checkout Consent'] ===
            consentText &&
          cart.attributes?.[
            'Checkout Consent Timestamp (UTC)'
          ] === timestamp &&
          cart.attributes?.[
            'Checkout Consent Version'
          ] === 'v2';

        if (!consentSaved) {
          throw new Error(
            'Your consent could not be saved. Please try again.'
          );
        }

        window.location.href = `${storefrontRoot}checkout`;
      } catch (error) {
        checkoutButton.disabled = false;

        if (checkoutLabel) {
          checkoutLabel.textContent = 'checkout';
        }

        if (consentStatus) {
          consentStatus.textContent = error.message;
          consentStatus.hidden = false;
        }
      }
    });
  }
  const formatAudioTime = (seconds) => {
    if (!Number.isFinite(seconds)) return '-';
    return `${Math.floor(seconds / 60)}:${String(Math.floor(seconds % 60)).padStart(2, '0')}`;
  };
  const initAudio = (root) => {
    const player =
      $('audio', root) ||
      document.createElement('audio');

    if (!player.parentNode) {
      root.append(player);
    }

    let active = null;

    const trackNotes =
      $$('.pdp-track-title small', root);

    trackNotes.forEach((note) => {
      const text =
        note.textContent.trim();

      if (!text) return;

      const inner =
        document.createElement('span');

      inner.textContent = text;
      note.replaceChildren(inner);
    });

    const updateTrackNotes = () => {
      trackNotes.forEach((note) => {
        const inner =
          $('span', note);

        const row =
          note.closest('.pdp-track');

        if (!inner || !row) return;

        const overflow =
          Math.max(
            0,
            inner.scrollWidth -
              note.clientWidth
          );

        const shouldScroll =
          overflow > 2;

        row.classList.toggle(
          'has-scrolling-note',
          shouldScroll
        );

        row.style.setProperty(
          '--note-scroll-distance',
          `${overflow}px`
        );

        row.style.setProperty(
          '--note-scroll-duration',
          `${Math.max(
            3,
            1.5 + overflow / 45
          )}s`
        );

        if (shouldScroll) {
          note.title =
            inner.textContent;
        } else {
          note.removeAttribute('title');
        }
      });
    };

    requestAnimationFrame(
      updateTrackNotes
    );

    window.addEventListener(
      'resize',
      updateTrackNotes
    );

    const resetRow = (row) => {
      if (!row) return;

      row.classList.remove('active');

      row.style.setProperty(
        '--track-progress',
        '0%'
      );

      $('.play-symbol', row)
        ?.classList.remove(
          'pause-symbol'
        );

      const time =
        $('.pdp-track-time', row);

      if (time) {
        time.textContent =
          time.dataset.audioDuration ||
          '-';
      }
    };

    $$('[data-audio-src]', root).forEach(
      (button) =>
        button.addEventListener(
          'click',
          () => {
            const row =
              button.closest(
                '.pdp-track'
              ) || button;

            const source =
              button.dataset.audioSrc;

            if (!source) return;

            if (
              active === row &&
              !player.paused
            ) {
              return player.pause();
            }

            if (active !== row) {
              resetRow(active);

              active = row;

              row.classList.add(
                'active'
              );

              player.src = source;
            }

            player.play();
          }
        )
    );

    player.addEventListener(
      'play',
      () => {
        const icon =
          $('.play-symbol', active);

        icon?.classList.add(
          'pause-symbol'
        );
      }
    );

    player.addEventListener(
      'pause',
      () => {
        const icon =
          $('.play-symbol', active);

        icon?.classList.remove(
          'pause-symbol'
        );
      }
    );

    player.addEventListener(
      'timeupdate',
      () => {
        if (
          !active ||
          !player.duration
        ) {
          return;
        }

        active.style.setProperty(
          '--track-progress',
          `${
            (
              player.currentTime /
              player.duration
            ) * 100
          }%`
        );

        const time =
          $('.pdp-track-time', active);

        if (time) {
          time.textContent =
            `${formatAudioTime(
              player.currentTime
            )} / ${formatAudioTime(
              player.duration
            )}`;
        }
      }
    );

    player.addEventListener(
      'ended',
      () => {
        player.currentTime = 0;
        resetRow(active);
        active = null;
      }
    );
  };
  $$('[data-audio-player]').forEach(initAudio);

  $$('[data-progressive-video]').forEach((wrap) => $('button[data-video-id]', wrap)?.addEventListener('click', (event) => {
    const button = event.currentTarget; const host = button.dataset.videoType === 'vimeo' ? `https://player.vimeo.com/video/${button.dataset.videoId}?autoplay=1` : `https://www.youtube-nocookie.com/embed/${button.dataset.videoId}?rel=0&autoplay=1`;
    const frame = document.createElement('iframe'); frame.src = host; frame.title = button.getAttribute('aria-label'); frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'; frame.allowFullscreen = true; wrap.replaceChildren(frame);
  }));

  const gate = $('[data-freebie-gate]');
  let pendingFreebie = null;
  const openGate = (variant, name, trigger) => {
    if (!gate) return; pendingFreebie = { id: Number(variant), quantity: 1 }; sessionStorage.setItem('inlet-pending-freebie', JSON.stringify(pendingFreebie));
    $$('[data-freebie-name], [data-freebie-submit-name]', gate).forEach((node) => { node.textContent = name; }); openLayer(gate, trigger);
  };
  $$('[data-freebie-close]', gate || document).forEach((button) => button.addEventListener('click', () => closeLayer(gate)));
  gate?.addEventListener('mousedown', (event) => { if (event.target === gate) closeLayer(gate); });
  gate?.addEventListener('keydown', (event) => trap(event, gate));
  const freebieProductButtons = $$('[data-freebie-product-add]');

freebieProductButtons.forEach((button) => {
  const label = $('span', button);

  button.dataset.originalDisabled = String(button.disabled);
  button.dataset.defaultLabel =
    label?.textContent || 'add to bag · free';

  const showInBagAction = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'view bag';
  };

  const showInBagStatus = () => {
    if (button.dataset.inBag !== 'true' || !label) return;
    label.textContent = 'already in bag';
  };

  button.addEventListener('mouseenter', showInBagAction);
  button.addEventListener('mouseleave', showInBagStatus);
  button.addEventListener('focus', showInBagAction);
  button.addEventListener('blur', showInBagStatus);
});

const setFreebieButtons = (state) => {
  freebieProductButtons.forEach((button) => {
    const label = $('span', button);
    const unavailable =
      button.dataset.originalDisabled === 'true';

    if (!label) return;

    if (unavailable) {
      label.textContent = button.dataset.defaultLabel;
      button.disabled = true;
      return;
    }

    const alreadyInBag = state === 'added';

    button.dataset.inBag = String(alreadyInBag);

    label.textContent =
      state === 'just-added'
        ? 'yay, added to bag'
        : state === 'added'
          ? 'already in bag'
          : state === 'unlocked'
            ? 'add to bag · free'
            : `unlock + add ${button.dataset.productName || ''} · free`;

    button.disabled =
      state === 'just-added';

    if (state === 'added') {
      button.setAttribute(
        'aria-label',
        'Already in bag. View bag'
      );
    } else {
      button.removeAttribute('aria-label');
    }
  });

  $$('[data-freebie-view-bag]').forEach((link) => {
    link.hidden =
      state !== 'added' && state !== 'just-added';
  });
};

const syncFreebieButtonsWithCart = (cart) => {
  if (!freebieProductButtons.length) return;

  const inBag = freebieProductButtons.some(
    (button) =>
      getCartQuantity(button.dataset.variantId, cart) > 0
  );

  setFreebieButtons(
    inBag
      ? 'added'
      : localStorage.getItem(unlockKey) === 'true'
        ? 'unlocked'
        : 'locked'
  );
};

if (freebieProductButtons.length) {
  const refreshFreebieButtonState = () => {
    updateCount()
      .then(syncFreebieButtonsWithCart)
      .catch(() => {});
  };

  refreshFreebieButtonState();
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshFreebieButtonState();
  });
}
  $$('[data-freebie-product-add]').forEach((button) => button.addEventListener('click', async () => {
    if (button.dataset.inBag === 'true') {
      window.location.href = `${storefrontRoot}cart`;
      return;
    }

    if (localStorage.getItem(unlockKey) === 'true') {
      try {
        const result = await addItems([{ id: Number(button.dataset.variantId), quantity: 1 }]);
        setFreebieButtons(
          result?.alreadyInBag
            ? 'added'
            : 'just-added'
        );
      } catch (error) {
        const status = $('.product-form-status', button.closest('.product-form'));

        if (status) {
          status.textContent = error.message;
          status.hidden = false;
        }
      }
    }
    else openGate(button.dataset.variantId, button.dataset.productName, button);
  }));
  const gateError = gate ? $('.freebie-unlock-form .errors', gate) : null;
  if (gateError) {
    gateError.setAttribute('role', 'alert'); gateError.setAttribute('tabindex', '-1');
    gate.hidden = false; document.body.classList.add('overlay-open');
    requestAnimationFrame(() => { gateError.focus(); if (document.activeElement !== gateError) $('input[type="email"]', gate)?.focus(); });
  }
  const captured = $('[data-freebie-captured]');
  if (captured && !gateError) {
    localStorage.setItem(unlockKey, 'true');
    try { pendingFreebie = JSON.parse(sessionStorage.getItem('inlet-pending-freebie')) || { id: Number(captured.dataset.variantId), quantity: 1 }; } catch (_) { pendingFreebie = null; }
    setFreebieButtons('unlocked');
    if (pendingFreebie?.id) addItems([pendingFreebie]).then((result) => { sessionStorage.removeItem('inlet-pending-freebie'); captured.textContent = 'Yay, your freebie is in the bag.'; setFreebieButtons(result?.alreadyInBag ? 'added' : 'just-added'); }).catch((error) => { captured.textContent = error.message; });
  }

  const shop = $('[data-shop-section]');
  if (shop) {
    let view = 'libraries';
let instrument = 'all';
let role = 'all';
let query = '';

const shopViews = [
  'libraries',
  'bundles',
  'freebies'
];

const headings = {
  libraries: [
    'instruments',
    'Choose by instrument.'
  ],
  bundles: [
    'bundles',
    'Choose how you want to build your palette.'
  ],
  freebies: [
    'freebies',
    'Start here, for free.'
  ]
};

const viewButtons = $$(
  '[data-shop-view]',
  shop
);

const originalViewCounts = Object.fromEntries(
  viewButtons.map((button) => [
    button.dataset.shopView,
    $('strong', button)?.textContent || '0'
  ])
);

const matchesSearch = (card) => {
  if (!query) return true;

  const searchText =
    card.dataset.search || '';

  return query
    .split(' ')
    .every((term) =>
      searchText.includes(term)
    );
};

const getSearchCounts = () =>
  Object.fromEntries(
    shopViews.map((shopView) => [
      shopView,
      $$(
        `[data-product-grid="${shopView}"] [data-product-card]`,
        shop
      ).filter(matchesSearch).length
    ])
  );

const render = () => {
  const typedSearch =
    searchInput?.value.trim();

  const searchCounts =
    query ? getSearchCounts() : null;

  viewButtons.forEach((button) => {
    const selected =
      button.dataset.shopView === view;

    button.classList.toggle(
      'selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      String(selected)
    );

    const count = $('strong', button);

    if (count) {
      count.textContent = query
        ? searchCounts[
            button.dataset.shopView
          ]
        : originalViewCounts[
            button.dataset.shopView
          ];
    }
  });

  $$(
    '[data-instrument-filter]',
    shop
  ).forEach((button) => {
    const selected =
      button.dataset.instrumentFilter ===
      instrument;

    button.classList.toggle(
      'selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      String(selected)
    );
  });

  $$(
    '[data-role-filter]',
    shop
  ).forEach((button) => {
    const selected =
      button.dataset.roleFilter === role;

    button.classList.toggle(
      'selected',
      selected
    );

    button.setAttribute(
      'aria-pressed',
      String(selected)
    );
  });

  $$('[data-product-grid]', shop).forEach(
    (grid) => {
      grid.hidden =
        grid.dataset.productGrid !== view;
    }
  );

  const libraryFilters = $(
    '[data-library-filters]',
    shop
  );

  if (libraryFilters) {
    libraryFilters.hidden =
      view !== 'libraries';
  }

  const libraryBundlePrompt = $(
    '[data-library-byob-prompt]',
    shop
  );

  if (libraryBundlePrompt) {
    libraryBundlePrompt.hidden =
      view !== 'libraries' ||
      Boolean(query);
  }

  const bundleNudge = $(
    '[data-bundle-nudge]',
    shop
  );

  if (bundleNudge) {
    bundleNudge.hidden =
      view !== 'bundles' ||
      Boolean(query);
  }

  $('[data-view-label]', shop).textContent =
    headings[view][0];

  $('[data-view-heading]', shop).textContent =
    query
      ? `Results for “${
          typedSearch || query
        }”.`
      : headings[view][1];

  let shown = 0;

  $$(
    `[data-product-grid="${view}"] [data-product-card]`,
    shop
  ).forEach((card) => {
    const matchesFilters =
      view !== 'libraries' ||
      (
        (
          instrument === 'all' ||
          card.dataset.instrument ===
            instrument
        ) &&
        (
          role === 'all' ||
          card.dataset.role === role
        )
      );

    const match = query
      ? matchesSearch(card)
      : matchesFilters;

    card.hidden = !match;

    if (match) shown += 1;
  });

  const emptyState = $(
    '[data-empty-state]',
    shop
  );

  emptyState.hidden = shown > 0;

  if (!shown) {
    const emptyMessage = $(
      'p',
      emptyState
    );

    emptyMessage.textContent = query
      ? `no ${headings[view][0]} match “${
          typedSearch || query
        }”.`
      : 'no instruments match those filters.';
  }
};

const applySearch = (value) => {
  query = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

  instrument = role = 'all';

  if (!query) return;

  const counts = getSearchCounts();

  if (counts[view] > 0) return;

  const firstMatchingView =
    shopViews.find(
      (shopView) =>
        counts[shopView] > 0
    );

  if (firstMatchingView) {
    view = firstMatchingView;
  }
};

const clearSearch = () => {
  query = '';

  if (searchInput) {
    searchInput.value = '';
  }
};

viewButtons.forEach((button) => {
  button.addEventListener(
    'click',
    () => {
      view = button.dataset.shopView;
      instrument = role = 'all';

      render();

      $('#shop-views')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  );
});

$$(
  '[data-instrument-filter]',
  shop
).forEach((button) => {
  button.addEventListener(
    'click',
    () => {
      clearSearch();
      view = 'libraries';
      instrument =
        button.dataset.instrumentFilter;

      render();
    }
  );
});

$$(
  '[data-role-filter]',
  shop
).forEach((button) => {
  button.addEventListener(
    'click',
    () => {
      clearSearch();
      view = 'libraries';
      role = button.dataset.roleFilter;

      render();
    }
  );
});

$('[data-more-filters]', shop)
  ?.addEventListener(
    'click',
    (event) => {
      const row = $(
        '[data-role-filters]',
        shop
      );

      row.hidden = !row.hidden;

      event.currentTarget.setAttribute(
        'aria-expanded',
        String(!row.hidden)
      );

      event.currentTarget
        .querySelector('span')
        .textContent =
          row.hidden ? '+' : '−';
    }
  );

$('[data-clear-filters]', shop)
  ?.addEventListener(
    'click',
    () => {
      instrument = role = 'all';

      clearSearch();
      render();
    }
  );

searchInput?.addEventListener(
  'input',
  () => {
    applySearch(searchInput.value);
    render();

    if (query) {
      $('#shop-views')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
);

searchPanel?.addEventListener(
  'submit',
  (event) => {
    event.preventDefault();

    applySearch(searchInput.value);
    render();
    setSearch(false);

    $('#shop-views')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
);

const params =
  new URLSearchParams(
    location.search
  );

if (
  ['bundles', 'freebies'].includes(
    params.get('view')
  )
) {
  view = params.get('view');
}

if (params.get('instrument')) {
  view = 'libraries';
  instrument =
    params
      .get('instrument')
      .toLowerCase();
}

if (params.get('search')) {
  if (searchInput) {
    searchInput.value =
      params.get('search');
  }

  applySearch(
    params.get('search')
  );
}

render();

        const modal = $('[data-quick-modal]', shop); let modalProduct = null;

    const eaQuickGate =
      $('[data-ea-quick-gate]', shop);

    const setEaQuickGateName = () => {
      if (
        !eaQuickGate ||
        earlyAccess.state !== 'active' ||
        !earlyAccess.product?.title
      ) {
        return;
      }

      $$('[data-ea-quick-name]', eaQuickGate).forEach(
        (node) => {
          node.textContent =
            earlyAccess.product.title;
        }
      );
    };

    let pendingQuickEarlyAccess = null;

    const openEaQuickGate = (trigger) => {
      if (!eaQuickGate) return;

      pendingQuickEarlyAccess = {
        id: Number(
          earlyAccess.product.variantId
        ),
        quantity: 1
      };

      try {
        sessionStorage.setItem(
          'inlet-pending-quick-early-access',
          JSON.stringify(
            pendingQuickEarlyAccess
          )
        );
      } catch (_) {}

      setEaQuickGateName();
      openLayer(eaQuickGate, trigger);
    };

    $('[data-ea-quick-close]', eaQuickGate || document)
      ?.addEventListener(
        'click',
        () => closeLayer(eaQuickGate)
      );

    eaQuickGate?.addEventListener(
      'mousedown',
      (event) => {
        if (event.target === eaQuickGate) {
          closeLayer(eaQuickGate);
        }
      }
    );

    eaQuickGate?.addEventListener(
      'keydown',
      (event) => trap(event, eaQuickGate)
    );

    const eaQuickError =
      eaQuickGate
        ? $('.ea-quick-unlock-form .errors', eaQuickGate)
        : null;

    if (
      eaQuickError &&
      earlyAccess.state === 'active'
    ) {
      setEaQuickGateName();
      openLayer(eaQuickGate);

      eaQuickError.setAttribute(
        'role',
        'alert'
      );

      eaQuickError.setAttribute(
        'tabindex',
        '-1'
      );

      requestAnimationFrame(() => {
        eaQuickError.focus();
      });
    }

    const eaQuickCaptured =
      $('[data-ea-quick-captured]', shop);

    if (eaQuickCaptured && !eaQuickError) {
      if (
        earlyAccess.state === 'active' &&
        earlyAccess.browserUnlockKey
      ) {
        try {
          localStorage.setItem(
            earlyAccess.browserUnlockKey,
            'true'
          );
        } catch (_) {}

        earlyAccess.unlocked = true;

        try {
          pendingQuickEarlyAccess =
            JSON.parse(
              sessionStorage.getItem(
                'inlet-pending-quick-early-access'
              )
            ) || {
              id: Number(
                earlyAccess.product.variantId
              ),
              quantity: 1
            };
        } catch (_) {
          pendingQuickEarlyAccess = {
            id: Number(
              earlyAccess.product.variantId
            ),
            quantity: 1
          };
        }

        if (pendingQuickEarlyAccess?.id) {
          addItems([
            pendingQuickEarlyAccess
          ])
            .then((result) => {
              try {
                sessionStorage.removeItem(
                  'inlet-pending-quick-early-access'
                );
              } catch (_) {}

              eaQuickCaptured.textContent =
                result?.alreadyInBag
                  ? 'Already in your bag.'
                  : `${earlyAccess.product.title} is in your bag.`;
            })
            .catch((error) => {
              eaQuickCaptured.textContent =
                error.message;
            });
        }
      } else {
        eaQuickCaptured.textContent =
          'Early Access has ended.';
      }
    }

    $$('[data-quick-view]', shop).forEach(
      (button) =>
        button.addEventListener('click', async () => {
          const template = document.getElementById(
            button.dataset.quickView
          );
const node =
  template.content.firstElementChild.cloneNode(true);

modalProduct = node.dataset;

const productCard =
  button.closest('[data-product-card]');

const isEarlyAccessProduct =
  earlyAccess.state === 'active' &&
  String(productCard?.dataset.productId) ===
    String(earlyAccess.product?.id);
      modal.dataset.productKind = modalProduct.kind || '';
      $('[data-modal-title]', modal).textContent = modalProduct.title; $('[data-modal-descriptor]', modal).textContent = modalProduct.descriptor; $('[data-modal-description]', modal).textContent = modalProduct.description; $('[data-modal-link]', modal).href = modalProduct.productUrl;
$('[data-modal-error]', modal).hidden = true;

const modalViewBag = $('[data-modal-view-bag]', modal);
if (modalViewBag) modalViewBag.hidden = true;
      const note = $('[data-modal-note]', modal);
      note.textContent = modalProduct.note || '';
      note.hidden = !modalProduct.note;

      const eaSummary =
        $('[data-modal-ea-summary]', modal);

      if (eaSummary) {
        eaSummary.hidden =
          !isEarlyAccessProduct;
      }

      modal.dataset.earlyAccess =
        String(isEarlyAccessProduct);

      if (isEarlyAccessProduct) {
        $('[data-modal-ea-price]', modal)
          .textContent =
            money(earlyAccess.product.price);

        const eaCompare =
          $('[data-modal-ea-compare]', modal);

        if (
          Number(earlyAccess.product.compareAtPrice) >
          Number(earlyAccess.product.price)
        ) {
          eaCompare.textContent =
            money(
              earlyAccess.product.compareAtPrice
            );

          eaCompare.hidden = false;
        } else {
          eaCompare.hidden = true;
        }

        $('[data-modal-ea-saving]', modal)
          .textContent =
            `save ${earlyAccess.savingPercentage}%`;

        $('[data-modal-ea-time]', modal)
          .textContent =
            formatEarlyAccessTime(
              earlyAccess.endUnix
            );
      }

      const ui = $('.quick-ui-source', node); $('[data-modal-ui]', modal).replaceChildren(...[...ui.childNodes].map((n) => n.cloneNode(true)));
      const visual = $('[data-modal-visual]', modal);visual.style.setProperty(
  '--modal-accent',
  modalProduct.accent || '#77746f',
);
visual.style.setProperty(
  '--modal-deep',
  modalProduct.deep || '#1c1a18',
); modal.style.setProperty(
  '--modal-deep',
  modalProduct.deep || '#1c1a18',
);
modal.style.setProperty(
  '--modal-soft',
  modalProduct.soft || '#c7b1ff',
);const mood = $('.quick-mood-source img', node); $('.modal-mood-source', visual)?.remove(); if (mood) { const clone = mood.cloneNode(true); clone.className = 'modal-mood-source'; visual.prepend(clone); visual.classList.add('has-mood-image'); $('.mood-placeholder', visual).hidden = true; } else { visual.classList.remove('has-mood-image'); $('.mood-placeholder', visual).hidden = false; }
      const value = $('[data-modal-value]', modal); value.hidden = modalProduct.kind !== 'bundle'; if (modalProduct.kind === 'bundle') { $('[data-modal-compare]', modal).textContent = modalProduct.compare || '-'; $('[data-modal-price]', modal).textContent = modalProduct.price; $('[data-modal-saving]', modal).textContent = modalProduct.saving ? `${modalProduct.discount} · save ${modalProduct.saving}` : ''; }
      const audio = $('[data-modal-audio]', modal); audio.replaceChildren(); audio.hidden = modalProduct.kind === 'freebie'; const audioSource = $('.quick-audio-source', node); if (modalProduct.kind !== 'freebie') { audio.innerHTML = '<div class="audio-heading"><span>audio demos</span><small>listen</small></div><div class="audio-track-list"></div><audio preload="metadata"></audio>'; const list = $('.audio-track-list', audio); [...audioSource.children].forEach((track) => list.append(track.cloneNode(true))); initAudio(audio); }
            const video = $('[data-modal-video]', modal); const facts = $('[data-modal-facts]', modal); video.replaceChildren();
video.hidden = true;
facts.hidden = true; if (modalProduct.kind === 'freebie') {
  $('[data-modal-preview-title]', facts).textContent = `inside ${modalProduct.title}`;
  const list = $('ul', facts);
  list.replaceChildren(...$$('.quick-facts-source li', node).map((item) => item.cloneNode(true)));
  if (!list.children.length) [modalProduct.includedSummary, modalProduct.compatibility].filter(Boolean).forEach((text) => { const item = document.createElement('li'); item.textContent = text; list.append(item); });
  facts.hidden = false;

  const source = $('.quick-video-source', node);
  if (source?.firstElementChild) {
    const preview = source.firstElementChild.cloneNode(true);
    video.append(preview);
    video.hidden = false;
    preview.addEventListener('click', () => { const host = preview.dataset.videoType === 'vimeo' ? `https://player.vimeo.com/video/${preview.dataset.videoId}?autoplay=1` : `https://www.youtube-nocookie.com/embed/${preview.dataset.videoId}?rel=0&autoplay=1`; const frame = document.createElement('iframe'); frame.src = host; frame.title = `${modalProduct.title} articulation playthrough`; frame.allow = 'autoplay; encrypted-media; picture-in-picture'; frame.allowFullscreen = true; video.replaceChildren(frame); });
  }
} else if (modalProduct.kind === 'bundle') { $('[data-modal-preview-title]', facts).textContent = 'included + compatibility'; const list = $('ul', facts); list.replaceChildren(); [modalProduct.includedSummary, modalProduct.compatibility].filter(Boolean).forEach((text) => { const item = document.createElement('li'); item.textContent = text; list.append(item); }); facts.hidden = false; }
      const add = $('[data-modal-add]', modal);
const unlocked = localStorage.getItem(unlockKey) === 'true';
let quickCart = cartSnapshot;

try {
  quickCart = await updateCount();
} catch (_) {}

const inBag =
  getCartQuantity(modalProduct.variantId, quickCart) > 0;

const lockedEarlyAccess =
  isEarlyAccessProduct &&
  !earlyAccess.unlocked &&
  !inBag;

if (modalViewBag) modalViewBag.hidden = true;

add.dataset.inBag = String(inBag);

add.hidden = false;

add.disabled =
  modalProduct.available !== 'true';

add.textContent =
  modalProduct.available !== 'true'
    ? 'unavailable'
    : inBag
      ? 'already in bag · view bag'
      : lockedEarlyAccess
        ? 'unlock early access + add to bag'
        : modalProduct.kind === 'freebie'
          ? unlocked
            ? 'add to bag · free'
            : `unlock + add ${modalProduct.title} · free`
          : `add to bag · ${modalProduct.price}`;

const returnFocus =
  button._inletReturnFocus || button;

button._inletReturnFocus = null;

openLayer(modal, returnFocus);
    }));

    const stopQuickViewMedia = () => {
      const player = $('audio', modal);

      if (player) {
        player.pause();

        try {
          player.currentTime = 0;
        } catch (_) {}

        player.removeAttribute('src');
        player.load();
      }

      $$('.pdp-track', modal).forEach((row) => {
        row.classList.remove('active');
        row.style.setProperty('--track-progress', '0%');
        $('.play-symbol', row)?.classList.remove('pause-symbol');

        const time = $('.pdp-track-time', row);

        if (time) {
          time.textContent =
            time.dataset.audioDuration || '-';
        }
      });

      const video = $('[data-modal-video]', modal);

      if (video?.querySelector('iframe')) {
        video.replaceChildren();
      }
    };

    const closeQuickView = () => {
      stopQuickViewMedia();
      closeLayer(modal);
    };

    $('[data-modal-close]', modal)?.addEventListener(
      'click',
      closeQuickView
    );

    modal?.addEventListener('mousedown', (event) => {
      if (event.target === modal) closeQuickView();
    });

    modal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeQuickView();
        return;
      }

      trap(event, modal);
    });
    $('[data-modal-add]', modal)?.addEventListener(
  'click',
  async (event) => {
    if (!modalProduct) return;

    const button = event.currentTarget;
    const trigger = lastFocus;

    if (button.dataset.inBag === 'true') {
      window.location.href = `${storefrontRoot}cart`;
      return;
    }

    if (
      modal.dataset.earlyAccess === 'true' &&
      !earlyAccess.unlocked
    ) {
      closeQuickView();
      openEaQuickGate(trigger);
      return;
    }

    if (
      modalProduct.kind === 'freebie' &&
      localStorage.getItem(unlockKey) !== 'true'
    ) {
      closeQuickView();
      openGate(
        modalProduct.variantId,
        modalProduct.title,
        trigger
      );
      return;
    }

    const originalLabel = button.textContent;

    button.disabled = true;
    button.textContent = 'adding to bag…';

    try {
      const result = await addItems([
        {
          id: Number(modalProduct.variantId),
          quantity: 1
        }
      ]);

      button.dataset.inBag = 'true';

      button.textContent =
        result?.alreadyInBag
          ? 'already in bag · view bag'
          : 'yay, added to bag';

      button.disabled = !result?.alreadyInBag;

const modalViewBag = $('[data-modal-view-bag]', modal);
if (modalViewBag) modalViewBag.hidden = false;
    } catch (error) {
      const status = $('[data-modal-error]', modal);

      status.textContent = error.message;
      status.hidden = false;

      button.disabled = false;
      button.textContent = originalLabel;
    }
  }
);

 const builder = $('[data-bundle-modal]', shop);

let selected = [];
let bagLibraries = [];
let builderCartSignature = null;
let touchedBundleProducts = new Set();
let builderJustUpdated = false;
let builderDisplayOrder = [];
let builderPromotedDuplicateIds = new Set();
let lastRenderedBundleTier = null;
let bundleTierAnimationTimer = null;

const bundleSlots = $('[data-bundle-slots]', builder);
const bundleSlotsPrev = $('[data-bundle-slots-prev]', builder);
const bundleSlotsNext = $('[data-bundle-slots-next]', builder);

const getBundleSlotScrollStep = () => {
  if (!bundleSlots) return 0;

  const firstSlot = $('.bundle-slot', bundleSlots);

  if (!firstSlot) return 0;

  const styles = getComputedStyle(bundleSlots);
  const gap =
    Number.parseFloat(styles.columnGap || styles.gap) || 0;

  const slotWidth =
    firstSlot.getBoundingClientRect().width;

  return Math.max(
    slotWidth + gap,
    bundleSlots.clientWidth - slotWidth - gap
  );
};

const updateBundleSlotNavigation = () => {
  if (!bundleSlots) return;

  const maxScroll = Math.max(
    0,
    bundleSlots.scrollWidth - bundleSlots.clientWidth
  );

  const hasOverflow = maxScroll > 2;

  if (bundleSlotsPrev) {
    bundleSlotsPrev.hidden =
      !hasOverflow || bundleSlots.scrollLeft <= 2;
  }

  if (bundleSlotsNext) {
    bundleSlotsNext.hidden =
      !hasOverflow ||
      bundleSlots.scrollLeft >= maxScroll - 2;
  }
};

const scrollBundleSlots = (direction) => {
  if (!bundleSlots) return;

  const step = getBundleSlotScrollStep();

  if (!step) return;

  bundleSlots.scrollBy({
    left: step * direction,
    behavior: window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches
      ? 'auto'
      : 'smooth'
  });
};

bundleSlotsPrev?.addEventListener('click', () => {
  scrollBundleSlots(-1);
});

bundleSlotsNext?.addEventListener('click', () => {
  scrollBundleSlots(1);
});

bundleSlots?.addEventListener('scroll', () => {
  updateBundleSlotNavigation();
});

bundleSlots?.addEventListener('keydown', (event) => {
  if (
    event.key !== 'ArrowLeft' &&
    event.key !== 'ArrowRight'
  ) {
    return;
  }

  event.preventDefault();
  scrollBundleSlots(event.key === 'ArrowRight' ? 1 : -1);
});

window.addEventListener('resize', () => {
  updateBundleSlotNavigation();
});

    const getBundleTier = (count) =>
      count >= 5
        ? 20
        : count >= 3
          ? 15
          : count >= 2
            ? 10
            : 0;

    const animateBundleTierIncrease = (tier) => {
      const reward = $('[data-bundle-reward]', builder);

      if (
        !reward ||
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
      ) {
        return;
      }

      if (bundleTierAnimationTimer) {
        window.clearTimeout(bundleTierAnimationTimer);
      }

      reward.classList.remove(
        'is-tier-up',
        'is-tier-max'
      );

      void reward.offsetWidth;

      reward.classList.add('is-tier-up');

      if (tier === 20) {
        reward.classList.add('is-tier-max');
      }

      bundleTierAnimationTimer = window.setTimeout(
        () => {
          reward.classList.remove(
            'is-tier-up',
            'is-tier-max'
          );

          bundleTierAnimationTimer = null;
        },
        620
      );
    };

    const getBundlePickerHeading = (count) => {
      if (count === 0) return 'choose a library.';
      if (count === 1) return 'add 1 more for 10% off.';
      if (count === 2) return 'add 1 more for 15% off.';
      if (count === 3) return 'add 2 more for 20% off.';
      if (count === 4) return 'add 1 more for 20% off.';
      return '20% unlocked on every library.';
    };

    const getBundleProduct = (button) => ({
  id: Number(button.dataset.variantId),
  price: Number(button.dataset.price),
  name: button.dataset.name,
  image: button.dataset.image || '',
  secondaryImage: button.dataset.secondaryImage || '',
  available:
    button.dataset.available !== 'false' &&
    !button.hasAttribute('disabled'),
  inBag: false,
  quantity: 1
});

    const getBuilderProducts = () =>
      $$('[data-bundle-product]', builder)
        .map(getBundleProduct);

    const setBuilderError = (message = '') => {
      const status = $('[data-bundle-error]', builder);

      if (!status) return;

      status.textContent = message;
      status.hidden = !message;
    };

    const syncBuilderCart = async () => {
      const cart = await updateCount();

      const productsByVariant = new Map(
        getBuilderProducts().map((product) => [
          product.id,
          product
        ])
      );

      const bagByVariant = new Map();

      (cart.items || []).forEach((item) => {
        const product = productsByVariant.get(
          Number(item.variant_id || item.id)
        );

        if (!product) return;

        const current = bagByVariant.get(product.id) || {
          ...product,
          inBag: true,
          quantity: 0
        };

        current.quantity += Number(item.quantity) || 0;
        bagByVariant.set(product.id, current);
      });

      const nextBagLibraries = [...bagByVariant.values()];

      const nextSignature = nextBagLibraries
        .map((item) => `${item.id}:${item.quantity}`)
        .sort()
        .join('|');

      const shouldResetDraft =
        builderCartSignature === null ||
        nextSignature !== builderCartSignature;

      bagLibraries = nextBagLibraries;

      if (shouldResetDraft) {
        const selectedIds = new Set(
          selected.map((item) => item.id)
        );

        const preservedSelection = selected
          .filter((item) => bagByVariant.has(item.id))
          .map((item) => ({
            ...bagByVariant.get(item.id),
            inBag: false
          }));

        const newBagLibraries = nextBagLibraries
          .filter((item) => !selectedIds.has(item.id))
          .map((item) => ({
            ...item,
            inBag: false
          }));

        selected = [
          ...preservedSelection,
          ...newBagLibraries
        ];

        touchedBundleProducts = new Set();
      }

      builderCartSignature = nextSignature;
    };

    const getBundleChanges = () => {
  const bagByVariant = new Map(
    bagLibraries.map((item) => [item.id, item])
  );

  const selectedByVariant = new Map(
    selected.map((item) => [item.id, item])
  );

  return {
    toAdd: selected.filter(
      (item) => !bagByVariant.has(item.id)
    ),
    quantityUpdates: bagLibraries
      .map((item) => {
        const selectedItem =
          selectedByVariant.get(item.id);

        return {
          id: item.id,
          from: Number(item.quantity) || 0,
          to: selectedItem
            ? Math.max(
                1,
                Number(selectedItem.quantity) || 1
              )
            : 0
        };
      })
      .filter((change) => change.to !== change.from)
  };
};

const updateBundleQuantities = async (changes) => {
  if (!changes.length) return;

  const cart = await updateCount();
  const updates = {};

  changes.forEach((change) => {
    const matchingLines = (cart.items || []).filter(
      (item) =>
        Number(item.variant_id || item.id) ===
        Number(change.id)
    );

    matchingLines.forEach((item, index) => {
      if (!item.key) return;

      updates[item.key] =
        index === 0 ? change.to : 0;
    });
  });

  if (!Object.keys(updates).length) return;

  const response = await fetch(
    `${storefrontRoot}cart/update.js`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    }
  );

  const result = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      result.description ||
      result.message ||
      'Unable to update the bag. Please try again.'
    );
  }
};

    const renderBuilder = () => {
  const allLibraries = selected;

  const currentLibraryIds = new Set(
    allLibraries.map((item) => item.id)
  );

  builderDisplayOrder = builderDisplayOrder.filter(
    (id) =>
      currentLibraryIds.has(id) ||
      builderPromotedDuplicateIds.has(id)
  );

  allLibraries.forEach((item) => {
    if (!builderDisplayOrder.includes(item.id)) {
      builderDisplayOrder.push(item.id);
    }
  });

  const newlyPromotedIds = allLibraries
    .filter((item) => {
      const quantity = Math.max(
        1,
        Number(item.quantity) || 1
      );

      return (
        quantity > 1 &&
        !builderPromotedDuplicateIds.has(item.id)
      );
    })
    .map((item) => item.id);

  newlyPromotedIds.forEach((id) => {
    builderPromotedDuplicateIds.add(id);
  });

  if (newlyPromotedIds.length) {
    const promotedIds = builderDisplayOrder.filter(
      (id) => builderPromotedDuplicateIds.has(id)
    );

    const regularIds = builderDisplayOrder.filter(
      (id) => !builderPromotedDuplicateIds.has(id)
    );

    builderDisplayOrder = [
      ...promotedIds,
      ...regularIds
    ];
  }

  const displayRank = new Map(
    builderDisplayOrder.map((id, index) => [
      id,
      index
    ])
  );

  const displayLibraries = allLibraries
    .map((item, selectedIndex) => ({
      item,
      selectedIndex
    }))
    .sort((a, b) => {
      const aRank = displayRank.get(a.item.id);
      const bRank = displayRank.get(b.item.id);

      if (
        aRank !== undefined &&
        bRank !== undefined
      ) {
        return aRank - bRank;
      }

      if (aRank !== undefined) return -1;
      if (bRank !== undefined) return 1;

      return a.selectedIndex - b.selectedIndex;
    })
    .map(({ item }) => item);

  const expandedLibraries = displayLibraries.flatMap((item) => {
    const quantity = Math.max(
      1,
      Number(item.quantity) || 1
    );

    return Array.from(
      { length: quantity },
      (_, unitIndex) => ({
        ...item,
        unitIndex,
        totalQuantity: quantity
      })
    );
  });

  const count = expandedLibraries.length;
  const tier = getBundleTier(count);

  const previousTier = lastRenderedBundleTier;
  const shouldAnimateTierIncrease =
    previousTier !== null &&
    tier > previousTier;

  lastRenderedBundleTier = tier;

  const subtotal = allLibraries.reduce(
    (sum, item) =>
      sum +
      item.price * Math.max(1, Number(item.quantity) || 1),
    0
  );

      const saving = Math.round(
        subtotal * tier / 100
      );

      const slotLabels = [
        'library 1',
        'library 2',
        'library 3',
        'library 4',
        'library 5+'
      ];

      const slotDetails = [
        'choose below',
        '10% off',
        '15% off',
        '15% off',
        '20% off'
      ];

      const slots = $('[data-bundle-slots]', builder);
      const minimumSlotCount = 5;
      const slotCount = Math.max(minimumSlotCount, count);

      slots.classList.toggle(
        'has-overflow',
        count > minimumSlotCount
      );

      slots.replaceChildren();

      for (let index = 0; index < slotCount; index += 1) {
        const item = expandedLibraries[index];

        const slot = document.createElement('div');

        const isEarlyAccessSlot =
          item &&
          earlyAccess.state === 'active' &&
          Number(item.id) ===
            Number(earlyAccess.product?.variantId);

        slot.className = [
          'bundle-slot',
          item ? 'filled' : '',
          isEarlyAccessSlot
            ? 'is-early-access'
            : '',
          !item && index === count
            ? 'is-next-slot'
            : ''
        ]
          .filter(Boolean)
          .join(' ');

        if (item?.image) {
          const art = document.createElement('span');

          art.className = [
            'bundle-slot-art',
            item.secondaryImage ? 'is-dual' : ''
          ]
            .filter(Boolean)
            .join(' ');

          const image = document.createElement('img');

          image.className = 'bundle-slot-image';
          image.src = item.image;
          image.alt = '';

          art.append(image);

          if (item.secondaryImage) {
            const secondaryImage = document.createElement('img');

            secondaryImage.className = 'bundle-slot-image';
            secondaryImage.src = item.secondaryImage;
            secondaryImage.alt = '';

            art.append(secondaryImage);
          }

          slot.append(art);
        }

        const copy = document.createElement('div');
        copy.className = 'bundle-slot-copy';

        const title = document.createElement('strong');
        title.className = 'bundle-slot-title';

        title.textContent = item
          ? item.name
          : slotLabels[index];

        copy.append(title);

        const detailText = item
  ? index === 0
    ? ''
    : slotDetails[
        Math.min(index, slotDetails.length - 1)
      ]
  : slotDetails[
      Math.min(index, slotDetails.length - 1)
    ];

const meta = document.createElement('span');
meta.className = 'bundle-slot-meta';

if (detailText) {
  const detail = document.createElement('span');

  detail.className = 'bundle-slot-offer';
  detail.textContent = detailText;

  meta.append(detail);
}

if (
  item &&
  item.totalQuantity > 1 &&
  item.unitIndex === 1
) {
  const quantity = document.createElement('span');

  quantity.className = 'bundle-slot-quantity';
  quantity.textContent =
    `in bag ×${item.totalQuantity}`;

  meta.append(quantity);
}

if (meta.childNodes.length) {
  copy.append(meta);
}

slot.append(copy);

if (item) {
  const remove = document.createElement('button');

  remove.type = 'button';
  remove.className = 'bundle-slot-remove';
  remove.setAttribute(
    'aria-label',
    `Remove one ${item.name} license`
  );
  remove.textContent = '×';

  remove.addEventListener('click', () => {
    builderJustUpdated = false;
    touchedBundleProducts.add(item.id);

    selected = selected
      .map((product) => {
        if (product.id !== item.id) {
          return product;
        }

        const quantity = Math.max(
          1,
          Number(product.quantity) || 1
        );

        return {
          ...product,
          quantity: quantity - 1
        };
      })
      .filter(
        (product) =>
          product.id !== item.id ||
          Number(product.quantity) > 0
      );

    renderBuilder();
  });

  slot.append(remove);
}

        slots.append(slot);
      }

      if (
        count <= minimumSlotCount ||
        newlyPromotedIds.length
      ) {
        slots.scrollLeft = 0;
      }

      requestAnimationFrame(
        updateBundleSlotNavigation
      );

      $('[data-bundle-reward]', builder).textContent =
        tier
          ? `${tier}% unlocked`
          : 'no saving yet';

      if (shouldAnimateTierIncrease) {
        animateBundleTierIncrease(tier);
      }

      $('[data-bundle-subtotal]', builder).textContent =
        money(subtotal);

      $('[data-bundle-saving]', builder).textContent =
        `−${money(saving)}`;

      $('[data-bundle-total]', builder).textContent =
        money(subtotal - saving);

      const savingRow = $(
        '[data-bundle-saving-row]',
        builder
      );

      savingRow.hidden = tier === 0;

      if (tier > 0) {
        $('[data-bundle-discount]', builder).textContent =
          `saving · ${tier}%`;
      }

      $('[data-bundle-picker-heading]', builder)
  .textContent = getBundlePickerHeading(count);

const clearButton = $('[data-bundle-clear]', builder);

if (clearButton) {
  clearButton.hidden = selected.length === 0;
}

const addButton = $('[data-add-bundle]', builder);
      const changes = getBundleChanges();
      const hasChanges =
  changes.toAdd.length > 0 ||
  changes.quantityUpdates.length > 0;

      addButton.disabled =
        !hasChanges && bagLibraries.length === 0;

addButton.textContent =
  hasChanges
    ? bagLibraries.length > 0
      ? 'update bag'
      : `add ${selected.length} ${
          selected.length === 1
            ? 'library'
            : 'libraries'
        } to bag`
    : bagLibraries.length > 0
      ? builderJustUpdated
        ? 'bag updated · view bag'
        : 'view bag'
      : 'add libraries to bag';

      $$('[data-bundle-product]', builder).forEach(
        (button) => {
          const product = getBundleProduct(button);

          const isEarlyAccessProduct =
            earlyAccess.state === 'active' &&
            Number(product.id) ===
              Number(earlyAccess.product?.variantId);

          button.classList.toggle(
            'is-early-access',
            isEarlyAccessProduct
          );

          const bagQuantity =
            bagLibraries.find(
              (item) => item.id === product.id
            )?.quantity || 0;

          const isSelected = selected.some(
            (item) => item.id === product.id
          );

          button.classList.toggle(
            'selected',
            isSelected
          );

          button.setAttribute(
  'aria-pressed',
  String(isSelected)
);

const selectedItem = selected.find(
  (item) => item.id === product.id
);

const selectedQuantity =
  Number(selectedItem?.quantity) || 0;

const matchesBag =
  bagQuantity > 0 &&
  selectedQuantity === bagQuantity;

button.classList.toggle(
  'is-in-bag',
  matchesBag
);

button.disabled =
  !product.available;

$('i', button).textContent =
  !product.available
    ? 'unavailable'
    : matchesBag
      ? `in bag${
          bagQuantity > 1
            ? ` ×${bagQuantity}`
            : ''
        }`
      : bagQuantity > 0
        ? `restore${
            bagQuantity > 1
              ? ` ×${bagQuantity}`
              : ''
          }`
        : isSelected
          ? 'remove'
          : 'add +';
        }
      );
    };

    const openBuilder = async (
      trigger,
      prefillHandles = [],
      legacyPrefillName = ''
    ) => {
      setBuilderError('');
builderJustUpdated = false;
builderDisplayOrder = [];
builderPromotedDuplicateIds = new Set();

try {
        await syncBuilderCart();
      } catch (error) {
        setBuilderError(error.message);
      }

      const addPrefillProduct = (match) => {
        if (!match || !getBundleProduct(match).available) {
          return;
        }

        const product = getBundleProduct(match);

        const alreadySelected = selected.some(
          (item) => item.id === product.id
        );

        if (!alreadySelected) {
          touchedBundleProducts.add(product.id);
          selected = [...selected, product];
        }
      };

      prefillHandles.forEach((handle) => {
        const match = $$(
          '[data-bundle-product]',
          builder
        ).find(
          (button) =>
            button.dataset.handle.toLowerCase() ===
            handle.toLowerCase()
        );

        addPrefillProduct(match);
      });

      if (
        prefillHandles.length === 0 &&
        legacyPrefillName
      ) {
        const legacyMatch = $$(
          '[data-bundle-product]',
          builder
        ).find(
          (button) =>
            button.dataset.name.toLowerCase() ===
            legacyPrefillName.toLowerCase()
        );

        addPrefillProduct(legacyMatch);
      }

      renderBuilder();
      openLayer(builder, trigger);
    };

    $$('[data-open-builder]', shop).forEach(
      (button) =>
        button.addEventListener('click', () => {
          openBuilder(button);
        })
    );

    $('[data-builder-close]', builder)
  ?.addEventListener('click', () => {
    closeLayer(builder);
  });

$('[data-bundle-clear]', builder)
  ?.addEventListener('click', () => {
    setBuilderError('');
    builderJustUpdated = false;
    builderDisplayOrder = [];
    builderPromotedDuplicateIds = new Set();

    selected.forEach((item) => {
      touchedBundleProducts.add(item.id);
    });

    selected = [];
    renderBuilder();
  });

builder?.addEventListener(
      'mousedown',
      (event) => {
        if (event.target === builder) {
          closeLayer(builder);
        }
      }
    );

    builder?.addEventListener(
      'keydown',
      (event) => trap(event, builder)
    );

    $$('[data-bundle-product]', builder).forEach(
      (button) =>
        button.addEventListener('click', () => {
  setBuilderError('');
  builderJustUpdated = false;

  const item = getBundleProduct(button);

          if (!item.available) return;

          const bagItem = bagLibraries.find(
  (product) => product.id === item.id
);

const selectedItem = selected.find(
  (product) => product.id === item.id
);

if (bagItem) {
  const bagQuantity =
    Number(bagItem.quantity) || 1;

  const selectedQuantity =
    Number(selectedItem?.quantity) || 0;

  touchedBundleProducts.add(item.id);

  if (selectedQuantity === bagQuantity) {
    selected = selected.filter(
      (product) => product.id !== item.id
    );

    renderBuilder();
    return;
  }

  selected = [
    ...selected.filter(
      (product) => product.id !== item.id
    ),
    {
      ...bagItem,
      inBag: false
    }
  ];

  renderBuilder();
  return;
}

touchedBundleProducts.add(item.id);

selected = selectedItem
  ? selected.filter(
      (product) => product.id !== item.id
    )
  : [
      ...selected,
      {
        ...item,
        quantity: 1
      }
    ];

renderBuilder();
        })
    );

    $('[data-add-bundle]', builder)
      ?.addEventListener(
        'click',
        async (event) => {
          const changes = getBundleChanges();
          const hasChanges =
  changes.toAdd.length > 0 ||
  changes.quantityUpdates.length > 0;

          if (!hasChanges) {
            if (bagLibraries.length > 0) {
              window.location.href =
                `${storefrontRoot}cart`;
            }

            return;
          }

          const button = event.currentTarget;

          setBuilderError('');
          button.disabled = true;
          button.textContent = 'updating bag…';

          try {
            if (changes.toAdd.length > 0) {
              await addItems(
                changes.toAdd.map((item) => ({
                  id: item.id,
                  quantity: 1
                }))
              );
            }

            if (changes.quantityUpdates.length > 0) {
  await updateBundleQuantities(
    changes.quantityUpdates
  );
}

            await syncBuilderCart();
builderJustUpdated = true;
renderBuilder();
          } catch (error) {
            try {
              await syncBuilderCart();
            } catch (_) {}

            setBuilderError(error.message);
            renderBuilder();
          }
        }
      );

    const builderPrefillHandles = params
      .getAll('add')
      .flatMap((value) => value.split(','))
      .map((value) => value.trim())
      .filter(Boolean);

    if (
      params.get('builder') === 'true' ||
      builderPrefillHandles.length > 0 ||
      params.get('bundle')
    ) {
      openBuilder(
        null,
        builderPrefillHandles,
        params.get('bundle') || ''
      );
    }
  }

  $$('[data-hotspot]').forEach((button) => { const canvas = button.closest('[data-interface-canvas]'); const tooltip = $('[data-hotspot-tooltip]', canvas); const caption = $('[data-hotspot-caption]', button.closest('.pdp-interface-explorer')); const show = () => { tooltip.hidden = false; tooltip.style.setProperty('--tooltip-x', `${button.dataset.tooltipX}%`); tooltip.style.setProperty('--tooltip-y', `${button.dataset.tooltipY}%`); $('strong', tooltip).textContent = button.dataset.label; $('span', tooltip).textContent = button.dataset.description; if (caption) { caption.hidden = false; $('strong', caption).textContent = button.dataset.label; $('span', caption).textContent = button.dataset.description; } }; button.addEventListener('mouseenter', show); button.addEventListener('focus', show); button.addEventListener('click', (event) => { event.preventDefault(); show(); button.setAttribute('aria-expanded', 'true'); }); button.addEventListener('mouseleave', () => { if (!matchMedia('(hover: none)').matches) tooltip.hidden = true; }); button.addEventListener('blur', () => { if (!matchMedia('(hover: none)').matches) tooltip.hidden = true; }); });
  $$('[data-interface-switcher]').forEach((switcher) => {
    const controls = $$('[data-interface-select]', switcher);
    const panels = $$('[data-interface-panel]', switcher);
    const canvas = $('[data-interface-canvas]', switcher);
    const tooltip = $('[data-hotspot-tooltip]', canvas);

    const reducedMotion = matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    const desktopPointer = matchMedia(
      '(hover: hover) and (pointer: fine) and (min-width: 750px)'
    );

    let active = 'original';
    let manuallySelected = false;
    let timer = null;

    const closeHotspot = () => {
      if (tooltip) tooltip.hidden = true;

      $$('[data-hotspot]', canvas).forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
    };

    const setActive = (next, userInitiated = false) => {
      if (next === active) {
        if (userInitiated) {
          manuallySelected = true;
          clearInterval(timer);
          timer = null;
        }

        return;
      }

      if (userInitiated) closeHotspot();

      active = next;

      controls.forEach((button) => {
        const selected =
          button.dataset.interfaceSelect === active;

        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      panels.forEach((panel) => {
        const selected =
          panel.dataset.interfacePanel === active;

        panel.classList.toggle('is-active', selected);
        panel.setAttribute('aria-hidden', String(!selected));
      });

      if (userInitiated) {
        manuallySelected = true;
        clearInterval(timer);
        timer = null;
      }
    };

    const isPaused = () =>
      switcher.matches(':hover') ||
      switcher.contains(document.activeElement) ||
      (tooltip && !tooltip.hidden);

    const canAutoSwitch = () =>
      !manuallySelected &&
      desktopPointer.matches &&
      !reducedMotion.matches;

    const startTimer = () => {
      clearInterval(timer);
      timer = null;

      if (!canAutoSwitch()) return;

      timer = setInterval(() => {
        if (!isPaused()) {
          setActive(
            active === 'original' ? 'tape' : 'original'
          );
        }
      }, 7000);
    };

    controls.forEach((button) => {
      button.addEventListener('click', () => {
        setActive(
          button.dataset.interfaceSelect,
          true
        );
      });
    });

    reducedMotion.addEventListener?.('change', startTimer);
    desktopPointer.addEventListener?.('change', startTimer);

    startTimer();
  });
  const productPage = $('[data-product-page]');

  if (productPage) {
    const pageProductId =
      productPage.dataset.productId;

    const isEarlyAccessPage =
      earlyAccess.state === 'active' &&
      String(pageProductId) ===
        String(earlyAccess.product?.id);

    const eaStatus =
      $('[data-pdp-ea-status]', productPage);

    const eaPriceRow =
      $('[data-pdp-ea-price-row]', productPage);

    const eaPrice =
      $('[data-pdp-ea-price]', productPage);

    const eaCompare =
      $('[data-pdp-ea-compare]', productPage);

    const eaSaving =
      $('[data-pdp-ea-saving]', productPage);

    const eaTime =
      $('[data-pdp-ea-time]', productPage);

    const standardPrice =
      $('[data-pdp-standard-price]', productPage);

    const eaUnlockButtons =
      $$('[data-pdp-ea-unlock]', productPage);

    const eaGate =
      $('[data-ea-pdp-gate]', productPage);

    const heroProductForm =
      $('#HeroProductForm', productPage);

    const stickyProductForm =
      $('#StickyProductForm', productPage);

    const sticky =
      $('[data-sticky-buy]', productPage);

    const footer =
      $('[data-site-footer]');

    let lockedEarlyAccess =
      isEarlyAccessPage &&
      !earlyAccess.unlocked;

    const applyEarlyAccessPageState = () => {
      lockedEarlyAccess =
        isEarlyAccessPage &&
        !earlyAccess.unlocked;

      if (eaStatus) {
        eaStatus.hidden =
          !isEarlyAccessPage;
      }

      if (eaPriceRow) {
        eaPriceRow.hidden =
          !isEarlyAccessPage;
      }

      if (standardPrice) {
        standardPrice.hidden =
          isEarlyAccessPage;
      }

      if (isEarlyAccessPage) {
        productPage.classList.add(
          'is-early-access-product'
        );

        if (eaTime) {
          eaTime.textContent =
            formatEarlyAccessTime(
              earlyAccess.endUnix
            );
        }

        if (eaPrice) {
          eaPrice.textContent =
            money(
              earlyAccess.product.price
            );
        }

        if (eaSaving) {
          eaSaving.textContent =
            `save ${earlyAccess.savingPercentage}%`;
        }

        if (eaCompare) {
          const hasComparePrice =
            Number(
              earlyAccess.product.compareAtPrice
            ) >
            Number(
              earlyAccess.product.price
            );

          eaCompare.hidden =
            !hasComparePrice;

          if (hasComparePrice) {
            eaCompare.textContent =
              money(
                earlyAccess.product.compareAtPrice
              );
          }
        }

        const stickyPrice =
          $('[data-sticky-buy] > span > small', productPage);

        if (stickyPrice) {
          stickyPrice.textContent =
            money(
              earlyAccess.product.price
            );
        }
      } else {
        productPage.classList.remove(
          'is-early-access-product'
        );
      }

      if (heroProductForm) {
        heroProductForm.hidden =
          lockedEarlyAccess;
      }

      if (stickyProductForm) {
        stickyProductForm.hidden =
          lockedEarlyAccess;
      }

      eaUnlockButtons.forEach(
        (button) => {
          button.hidden =
            !lockedEarlyAccess;
        }
      );
    };

    const captured =
      $('[data-ea-pdp-captured]');

    applyEarlyAccessPageState();

    let pendingEarlyAccess = null;

    eaUnlockButtons.forEach(
      (button) => {
        button.addEventListener(
          'click',
          () => {
            if (!eaGate) return;

            pendingEarlyAccess = {
              id: Number(
                earlyAccess.product.variantId
              ),
              quantity: 1
            };

            try {
              sessionStorage.setItem(
                'inlet-pending-early-access',
                JSON.stringify(
                  pendingEarlyAccess
                )
              );
            } catch (_) {}

            openLayer(
              eaGate,
              button
            );
          }
        );
      }
    );

    $('[data-ea-pdp-close]', eaGate || document)
      ?.addEventListener(
        'click',
        () => {
          closeLayer(eaGate);
        }
      );

    eaGate?.addEventListener(
      'mousedown',
      (event) => {
        if (event.target === eaGate) {
          closeLayer(eaGate);
        }
      }
    );

    eaGate?.addEventListener(
      'keydown',
      (event) => {
        trap(event, eaGate);
      }
    );

    const eaGateError =
      eaGate
        ? $('.ea-pdp-unlock-form .errors', eaGate)
        : null;

    if (
      eaGateError &&
      isEarlyAccessPage
    ) {
      openLayer(
        eaGate,
        eaUnlockButtons[0]
      );

      eaGateError.setAttribute(
        'role',
        'alert'
      );

      eaGateError.setAttribute(
        'tabindex',
        '-1'
      );

      requestAnimationFrame(() => {
        eaGateError.focus();
      });
    }

    if (
      captured &&
      !eaGateError &&
      earlyAccess.browserUnlockKey
    ) {
      try {
        localStorage.setItem(
          earlyAccess.browserUnlockKey,
          'true'
        );
      } catch (_) {}

      earlyAccess.unlocked = true;

      try {
        pendingEarlyAccess =
          JSON.parse(
            sessionStorage.getItem(
              'inlet-pending-early-access'
            )
          ) || {
            id: Number(
              captured.dataset.variantId
            ),
            quantity: 1
          };
      } catch (_) {
        pendingEarlyAccess = {
          id: Number(
            captured.dataset.variantId
          ),
          quantity: 1
        };
      }

      applyEarlyAccessPageState();

      if (pendingEarlyAccess?.id) {
        addItems([
          pendingEarlyAccess
        ])
          .then((result) => {
            try {
              sessionStorage.removeItem(
                'inlet-pending-early-access'
              );
            } catch (_) {}

            if (result?.cart) {
              syncProductFormsWithCart(
                result.cart
              );
            }

            captured.textContent =
              result?.alreadyInBag
                ? 'Already in your bag.'
                : 'Added to your bag.';
          })
          .catch((error) => {
            captured.textContent =
              error.message;
          });
      }
    }

    const heroButton =
      lockedEarlyAccess
        ? $('[data-pdp-ea-unlock]', productPage)
        : $(
            '#HeroProductForm button, #BundleHeroForm button, [data-freebie-page] .product-purchase [data-freebie-product-add]'
          );

    const stickyProductButton =
      $('#StickyProductForm button', productPage);

    if (stickyProductButton?.disabled) {
      $$('.product-purchase button, [data-sticky-buy] button', productPage)
        .forEach((button) => {
          button.disabled = true;
        });
    }

    if (heroButton && sticky) {
      new IntersectionObserver(
        ([entry]) => {
          const visible =
            !entry.isIntersecting &&
            entry.boundingClientRect.bottom <= 0;

          sticky.classList.toggle(
            'visible',
            visible
          );

          sticky.setAttribute(
            'aria-hidden',
            String(!visible)
          );

          if (visible) {
            sticky.removeAttribute('inert');
          } else {
            sticky.setAttribute('inert', '');
          }
        },
        { threshold: 0.01 }
      ).observe(heroButton);
    }

    const dock = () => {
      if (!sticky || !footer) return;

      const gutter =
        parseFloat(
          getComputedStyle(sticky)
            .getPropertyValue('--sticky-gutter')
        ) || 18;

      sticky.style.setProperty(
        '--sticky-footer-offset',
        `${Math.max(
          0,
          Math.ceil(
            innerHeight -
            footer.getBoundingClientRect().top -
            gutter
          )
        )}px`
      );
    };

    addEventListener(
      'scroll',
      dock,
      { passive: true }
    );

    addEventListener(
      'resize',
      dock
    );

    dock();

    const links =
      $$('[data-chapter-link]');

    const sections =
      links
        .map((a) =>
          document.getElementById(
            a.dataset.chapterLink
          )
        )
        .filter(Boolean);

    const chapter = () => {
      let active = '';

      sections.forEach((section) => {
        if (
          section.getBoundingClientRect().top <=
          innerHeight * .34
        ) {
          active = section.id;
        }
      });

      links.forEach((a) => {
        const current =
          a.dataset.chapterLink === active;

        a.classList.toggle(
          'section-active',
          current
        );

        if (current) {
          a.setAttribute(
            'aria-current',
            'location'
          );
        } else {
          a.removeAttribute(
            'aria-current'
          );
        }
      });
    };

    addEventListener(
      'scroll',
      chapter,
      { passive: true }
    );

    chapter();
  }

    const help = $('[data-help-page]');
  if (help) {
    let category = 'setup';

    const input = $('[data-help-search]', help);
    const searchForm = $('[data-help-search-form]', help);
    const answers = $('#answers', help);

    const renderHelp = () => {
      const query = input.value.trim().toLowerCase();
      let count = 0;

      $$('[data-faq-group]', help).forEach((group) => {
        let groupCount = 0;

        $$('details', group).forEach((item) => {
          const match =
            !query ||
            `${$('summary span', item).textContent} ${item.dataset.search}`
              .toLowerCase()
              .includes(query);

          item.hidden = !match;

          if (match) groupCount += 1;
        });

        group.hidden = query
          ? groupCount === 0
          : group.dataset.faqGroup !== category;

        count += query ? groupCount : 0;
      });

      $$('[data-help-category]', help).forEach((button) => {
        const selected =
          !query &&
          button.dataset.helpCategory === category;

        button.classList.toggle('selected', selected);
        button.setAttribute(
          'aria-pressed',
          String(selected)
        );
      });

      $('[data-help-clear]', help).hidden = !query;
      $('[data-help-empty]', help).hidden =
        !query || count > 0;

      const counter = $('[data-help-count]', help);
      counter.hidden = !query;

      if (query) {
        counter.textContent =
          `${count} ${count === 1 ? 'answer' : 'answers'} ` +
          `for “${input.value}”`;
      }
    };

    $$('[data-help-category]', help).forEach((button) => {
      button.addEventListener('click', () => {
        category = button.dataset.helpCategory;
        input.value = '';
        renderHelp();
      });
    });

    input.addEventListener('input', renderHelp);

    searchForm?.addEventListener('submit', (event) => {
      event.preventDefault();
      renderHelp();

      if (!input.value.trim() || !answers) return;

      const categories = $('.help-categories', help);
      const categoryHeight =
        categories?.getBoundingClientRect().height || 0;
      const targetTop =
        window.scrollY +
        answers.getBoundingClientRect().top -
        70 -
        categoryHeight -
        16;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth'
      });
    });

    $$('[data-help-clear]', help).forEach((button) => {
      button.addEventListener('click', () => {
        input.value = '';
        renderHelp();
        input.focus();
      });
    });

    renderHelp();
  }
  const cookieBanner = $('[data-cookie-banner]');
  const cookiePreferences = $('[data-cookie-preferences]');

  if (cookieBanner && cookiePreferences) {
    const cookieFeedback = $$('[data-cookie-feedback]');
    const cookieActionButtons = $$('[data-cookie-action]');

    const consentInputs = {
      preferences: $(
        '[data-cookie-consent="preferences"]',
        cookiePreferences
      ),
      analytics: $(
        '[data-cookie-consent="analytics"]',
        cookiePreferences
      ),
      marketing: $(
        '[data-cookie-consent="marketing"]',
        cookiePreferences
      ),
    };

        let privacyApi = null;
    let privacyReady = false;

        const cookiePreviewStorageKey =
      'inlet-cookie-choice-preview-v1';

    const isThemePreview = Boolean(
      window.Shopify?.designMode ||
      new URLSearchParams(
        window.location.search
      ).has('preview_theme_id')
    );

    const setCookieFeedback = (
      message = '',
      isError = false
    ) => {
      cookieFeedback.forEach((node) => {
        node.textContent = message;
        node.hidden = !message;
        node.classList.toggle('is-error', isError);
      });
    };

    const setCookieBusy = (busy) => {
      cookieActionButtons.forEach((button) => {
        button.disabled = busy;
      });
    };

    const populateCookiePreferences = () => {
      if (!privacyApi) return;

      const consent = privacyApi.currentVisitorConsent();

      Object.entries(consentInputs).forEach(([key, input]) => {
        if (input) input.checked = consent[key] === 'yes';
      });
    };

    const openCookiePreferences = (trigger) => {
      populateCookiePreferences();

      setCookieFeedback(
        privacyReady
          ? ''
          : 'privacy settings are still loading.'
      );

      openLayer(cookiePreferences, trigger);
    };

    const saveCookieConsent = (consent) =>
      new Promise((resolve, reject) => {
        if (!privacyApi) {
          reject(
            new Error(
              'privacy settings are not available yet. please try again.'
            )
          );

          return;
        }

        privacyApi.setTrackingConsent(
          consent,
          (result) => {
            if (result?.error) {
              const message = Array.isArray(result.error)
                ? result.error.join(' ')
                : String(result.error);

              reject(new Error(message));
              return;
            }

            resolve();
          }
        );
      });

    const applyCookieChoice = async (consent) => {
      setCookieBusy(true);
      setCookieFeedback('saving your choices…');

      try {
                await saveCookieConsent(consent);

        if (isThemePreview) {
          try {
            window.sessionStorage.setItem(
              cookiePreviewStorageKey,
              'saved'
            );
          } catch (error) {
            // Preview persistence is optional.
          }
        }

        cookieBanner.hidden = true;
        setCookieFeedback('choices saved.');

        if (!cookiePreferences.hidden) {
          closeLayer(cookiePreferences);
        }
      } catch (error) {
        setCookieFeedback(error.message, true);
      } finally {
        setCookieBusy(false);
      }
    };

    $$('[data-cookie-open-settings]').forEach(
      (button) => {
        button.addEventListener('click', () => {
          openCookiePreferences(button);
        });
      }
    );

        document.addEventListener('click', (event) => {
      const cookieSettingsLink =
        event.target.closest('[data-cookie-settings]');

      if (!cookieSettingsLink) return;

      event.preventDefault();
      openCookiePreferences(cookieSettingsLink);
    });

    $(
      '[data-cookie-preferences-close]',
      cookiePreferences
    )?.addEventListener('click', () => {
      closeLayer(cookiePreferences);
    });

    cookiePreferences.addEventListener(
      'mousedown',
      (event) => {
        if (event.target === cookiePreferences) {
          closeLayer(cookiePreferences);
        }
      }
    );

    cookiePreferences.addEventListener(
      'keydown',
      (event) => {
        trap(event, cookiePreferences);
      }
    );

    cookieActionButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const action = button.dataset.cookieAction;

        if (action === 'accept') {
          applyCookieChoice({
            preferences: true,
            analytics: true,
            marketing: true,
          });

          return;
        }

        if (action === 'reject') {
          applyCookieChoice({
            preferences: false,
            analytics: false,
            marketing: false,
          });

          return;
        }

        if (action === 'save') {
          applyCookieChoice({
            preferences: Boolean(
              consentInputs.preferences?.checked
            ),
            analytics: Boolean(
              consentInputs.analytics?.checked
            ),
            marketing: Boolean(
              consentInputs.marketing?.checked
            ),
          });
        }
      });
    });

    const initialiseCustomerPrivacy = () => {
      if (!window.Shopify?.loadFeatures) {
        setCookieFeedback(
          'privacy settings are temporarily unavailable.',
          true
        );

        return;
      }

      window.Shopify.loadFeatures(
        [
          {
            name: 'consent-tracking-api',
            version: '0.1',
          },
        ],
        (error) => {
          if (
            error ||
            !window.Shopify.customerPrivacy
          ) {
            setCookieFeedback(
              'privacy settings are temporarily unavailable.',
              true
            );

            return;
          }

          privacyApi =
            window.Shopify.customerPrivacy;

          privacyReady = true;

          populateCookiePreferences();
          setCookieFeedback('');

                    const currentConsent =
            privacyApi.currentVisitorConsent();

          const hasRecordedConsent = [
            'preferences',
            'analytics',
            'marketing',
          ].some(
            (key) =>
              currentConsent[key] === 'yes' ||
              currentConsent[key] === 'no'
          );

          let previewChoiceSaved = false;

          if (isThemePreview) {
            try {
              previewChoiceSaved =
                window.sessionStorage.getItem(
                  cookiePreviewStorageKey
                ) === 'saved';
            } catch (error) {
              previewChoiceSaved = false;
            }
          }

          cookieBanner.hidden =
            hasRecordedConsent ||
            previewChoiceSaved ||
            !privacyApi.shouldShowBanner();
        }
      );
    };

    document.addEventListener(
      'visitorConsentCollected',
      () => {
        populateCookiePreferences();
      }
    );

    initialiseCustomerPrivacy();
  }
  const reviewFormSelector = '.jdgm-form-wrapper';
  const reviewObservers = new WeakMap();

  const reviewFormIsVisible = (form) => {
    if (!form || form.hidden) return false;

    return (
      form.getAttribute('aria-hidden') !== 'true' &&
      window.getComputedStyle(form).display !== 'none'
    );
  };

  const getReviewContext = (source) => {
    const reviewSection = source?.closest?.('.pdp-reviews');

    if (!reviewSection) return null;

    const widget = reviewSection.querySelector(
      '#judgeme_product_reviews'
    );

    return {
      reviewSection,
      widget,
      form: reviewSection.querySelector(reviewFormSelector),
      dynamicForms: [
        ...reviewSection.querySelectorAll(
          '.jdgm-form-dynamic-wrapper'
        ),
      ],
      customTrigger: reviewSection.querySelector(
        '[data-review-write-trigger]'
      ),
      judgeMeTrigger: reviewSection.querySelector(
        '.jdgm-write-rev-link'
      ),
    };
  };

  const syncReviewState = (context) => {
    const expanded = reviewFormIsVisible(context?.form);

    context?.customTrigger?.setAttribute(
      'aria-expanded',
      String(expanded)
    );

    context?.judgeMeTrigger?.setAttribute(
      'aria-expanded',
      String(expanded)
    );

    return expanded;
  };

  const clearJudgeMeHash = () => {
    if (window.location.hash !== '#judgeme_product_reviews') {
      return;
    }

    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${window.location.search}`
    );
  };

  const preserveReviewViewport = (position) => {
    const root = document.documentElement;
    const previousOverflowAnchor =
      root.style.overflowAnchor;

    let remainingFrames = 4;

    root.style.overflowAnchor = 'none';

    const holdPosition = () => {
      window.scrollTo({
        left: position.left,
        top: position.top,
        behavior: 'auto',
      });

      remainingFrames -= 1;

      if (remainingFrames > 0) {
        window.requestAnimationFrame(holdPosition);
        return;
      }

      root.style.overflowAnchor = previousOverflowAnchor;
    };

    holdPosition();
  };

  const focusReviewForm = (context) => {
    const form = context?.form;

    if (!reviewFormIsVisible(form)) return;

    const focusTarget =
      form.querySelector('.jdgm-form__title') ||
      form.querySelector(
        '[role="radio"], textarea, input:not([type="hidden"]), select, button, [href]'
      );

    if (!focusTarget) return;

    if (
      !focusTarget.matches(
        'input, textarea, select, button, [href], [tabindex]'
      )
    ) {
      focusTarget.setAttribute('tabindex', '-1');
    }

    focusTarget.focus({ preventScroll: true });
  };

  const reviewFormHasDraft = (form) =>
    form?.dataset.inletReviewDirty === 'true';

  const enhanceReviewForm = (context) => {
    const form = context?.form;

    if (!form) return;

    if (form.dataset.inletReviewDraftTracking !== 'true') {
      const markDirty = () => {
        form.dataset.inletReviewDirty = 'true';
      };

      form.addEventListener('input', markDirty);
      form.addEventListener('change', markDirty);
      form.dataset.inletReviewDraftTracking = 'true';
    }

    [
      {
        selector: 'input[name="review_title"]',
        fallbackMax: 100,
      },
      {
        selector: 'textarea[name="review_body"]',
        fallbackMax: 5000,
      },
    ].forEach(({ selector, fallbackMax }) => {
      const control = form.querySelector(selector);
      const fieldset = control?.closest('.jdgm-form__fieldset');

      if (!control || !fieldset) return;

      let counter = fieldset.querySelector(
        '.inlet-review-character-count'
      );

      if (!counter) {
        counter = document.createElement('span');
        counter.className = 'inlet-review-character-count';
        counter.setAttribute('aria-hidden', 'true');
        fieldset.append(counter);
      }

      const hideNativeCounters = () => {
        fieldset
          .querySelectorAll('span, small, p, div')
          .forEach((node) => {
            if (
              node === counter ||
              node.contains(control) ||
              node.contains(counter)
            ) {
              return;
            }

            const text = node.textContent?.trim() || '';

            if (
              node.dataset.inletNativeCounterHidden !== 'true' &&
                            /^(?:\(\d+\)|\d+\s*\/\s*\d+(?:\s*(?:characters?|chars?))?|\d+\s+of\s+\d+|\d+\s+(?:characters?|chars?)(?:\s+(?:remaining|left))?)$/i.test(
                text
              )
            ) {
              node.dataset.inletNativeCounterHidden = 'true';
              node.style.setProperty(
                'display',
                'none',
                'important'
              );
            }
          });
      };

      const updateCounter = () => {
        const max =
          Number(control.getAttribute('maxlength')) ||
          fallbackMax;
        const length = control.value.length;

        counter.textContent = `${length} / ${max}`;
        counter.classList.toggle(
          'is-visible',
          length > 0
        );

        hideNativeCounters();
        window.requestAnimationFrame(hideNativeCounters);
      };

      if (control.dataset.inletCharacterCount !== 'true') {
        control.addEventListener('input', updateCounter);
        control.dataset.inletCharacterCount = 'true';
      }

      updateCounter();
    });
  };

  const observeReviewForm = (context) => {
    if (
      !context?.widget ||
      reviewObservers.has(context.widget)
    ) {
      return;
    }

    const observer = new MutationObserver(() => {
      const refreshedContext = getReviewContext(
        context.reviewSection
      );

      if (refreshedContext) {
        syncReviewState(refreshedContext);
      }
    });

    observer.observe(context.widget, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: [
        'style',
        'hidden',
        'aria-hidden',
      ],
    });

    reviewObservers.set(context.widget, observer);
  };

  const openReviewForm = (context) => {
    if (!context?.form) return;

    observeReviewForm(context);

    if (reviewFormIsVisible(context.form)) {
      enhanceReviewForm(context);
      focusReviewForm(context);
      return;
    }

    const viewport = {
      left: window.scrollX,
      top: window.scrollY,
    };

    /*
     * Show Judge.me's existing form directly. Its validation,
     * submission and success handling remain untouched.
     */
    context.form.hidden = false;
    context.form.style.setProperty('display', 'block');
    context.form.setAttribute('aria-hidden', 'false');

    syncReviewState(context);
    clearJudgeMeHash();
    preserveReviewViewport(viewport);

    window.requestAnimationFrame(() => {
      const refreshedContext =
        getReviewContext(context.reviewSection) || context;

      enhanceReviewForm(refreshedContext);
      focusReviewForm(refreshedContext);
    });
  };

  const closeReviewForm = (context) => {
    if (!context?.form) return;

    const viewport = {
      left: window.scrollX,
      top: window.scrollY,
    };

    context.form.style.setProperty('display', 'none');
    context.form.setAttribute('aria-hidden', 'true');

    context.dynamicForms.forEach((form) => {
      form.style.setProperty('display', 'none');
      form.setAttribute('aria-hidden', 'true');
    });

    syncReviewState(context);
    clearJudgeMeHash();
    preserveReviewViewport(viewport);

    window.requestAnimationFrame(() => {
      context.customTrigger?.focus({
        preventScroll: true,
      });
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const openTrigger = event.target.closest(
        [
          '[data-review-write-trigger]',
          '.pdp-reviews .jdgm-write-rev-link',
        ].join(', ')
      );

      if (openTrigger) {
        const context = getReviewContext(openTrigger);

        if (!context?.form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (reviewFormIsVisible(context.form)) {
          closeReviewForm(context);
        } else {
          openReviewForm(context);
        }

        return;
      }

      const cancelTrigger = event.target.closest(
        '.pdp-reviews .jdgm-cancel-rev'
      );

      if (cancelTrigger) {
        const context = getReviewContext(cancelTrigger);

        if (!context?.form) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        closeReviewForm(context);
      }
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    if (
      event.target.closest(
        '.modal-backdrop, .bundle-overlay, .freebie-gate-backdrop'
      )
    ) {
      return;
    }

    $$('.pdp-reviews').forEach((reviewSection) => {
      const context = getReviewContext(reviewSection);

      if (
        !context?.form ||
        !reviewFormIsVisible(context.form) ||
        context.form.contains(event.target) ||
        reviewFormHasDraft(context.form)
      ) {
        return;
      }

      closeReviewForm(context);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    if (
      $(
        '.modal-backdrop:not([hidden]), .bundle-overlay:not([hidden]), .freebie-gate-backdrop:not([hidden])'
      )
    ) {
      return;
    }

    const reviewSection = $$('.pdp-reviews').find((section) => {
      const context = getReviewContext(section);
      return reviewFormIsVisible(context?.form);
    });

    if (!reviewSection) return;

    const context = getReviewContext(reviewSection);

    if (!context?.form) return;

    event.preventDefault();
    closeReviewForm(context);
  });

  const reviewDisclosureControllers = new WeakMap();
  const reviewInitialCount = 3;
  const reviewBatchSize = 6;
  const reviewApiPageSize = 30;
  const reviewSortMap = {
    'most-recent': ['created_at', 'desc'],
    'highest-rating': ['rating', 'desc'],
    'lowest-rating': ['rating', 'asc'],
    'with-pictures': ['with_pictures', ''],
    'pictures-first': ['pictures_first', ''],
    'videos-first': ['videos_first', ''],
    'most-helpful': ['most_helpful', ''],
    'verified-only': ['verified_only', ''],
  };

  const createReviewDisclosureArrow = () => {
    const namespace = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(namespace, 'svg');
    const path = document.createElementNS(namespace, 'path');

    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    path.setAttribute('d', 'M4 12 12 4M6 4h6v6');

    svg.append(path);
    return svg;
  };

  const formatReviewDate = (timestamp) => {
    if (!timestamp) return;

    timestamp.classList.remove('jdgm-spinner');

    if (timestamp.textContent.trim()) return;

    const value =
      timestamp.getAttribute('datetime') || timestamp.dataset.content;
    const date = value ? new Date(value) : null;

    if (!date || Number.isNaN(date.getTime())) return;

    timestamp.textContent = new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  };

  const normaliseReviewCard = (review) => {
    review
      .querySelectorAll(
        [
          '.jdgm-rev__reply',
          '.jdgm-rev__custom-form',
          '.jdgm-rev__pics',
          '.jdgm-rev__vids',
        ].join(', ')
      )
      .forEach((element) => {
        const containsUsefulContent =
          element.textContent.trim() ||
          element.querySelector(
            'img, video, iframe, a, button, input'
          );

        if (!containsUsefulContent) {
          element.remove();
        }
      });

    const header = review.querySelector('.jdgm-rev__header');

    if (!header || header.querySelector('.jdgm-row-rating')) {
      return review;
    }

    const rating = header.querySelector('.jdgm-rev__rating');
    const timestamp = header.querySelector('.jdgm-rev__timestamp');
    const icon = header.querySelector('.jdgm-rev__icon');
    const author = header.querySelector('.jdgm-rev__author-wrapper');
    const badge = header.querySelector(
      '.jdgm-rev__buyer-badge-wrapper'
    );
    const location = header.querySelector('.jdgm-rev__location');
    const ratingRow = document.createElement('div');
    const profileRow = document.createElement('div');
    const extraRow = document.createElement('div');

    review.classList.add('jdgm--done-setup');
    ratingRow.className = 'jdgm-row-rating';
    profileRow.className = 'jdgm-row-profile';
    extraRow.className = 'jdgm-row-extra';

    if (rating) ratingRow.append(rating);

    if (timestamp) {
      formatReviewDate(timestamp);
      ratingRow.append(timestamp);
    }

    if (icon) profileRow.append(icon);

    if (author) {
      if (badge && review.dataset.verifiedBuyer === 'true') {
        author.append(badge);
      } else {
        badge?.remove();
      }

      profileRow.append(author);
    }

    if (location) extraRow.append(location);

    header.prepend(ratingRow, profileRow, extraRow);

    return review;
  };

  const initialiseReviewDisclosure = (widget) => {
    if (reviewDisclosureControllers.has(widget)) return;
    if (!widget.classList.contains('jdgm--done-setup-widget')) return;

    const root = widget.querySelector('.jdgm-rev-widg');
    let list = widget.querySelector('.jdgm-rev-widg__reviews');
    let pagination = widget.querySelector('.jdgm-paginate');

    if (!root || !list || !pagination) return;

    let totalCount =
      Number(root.dataset.numberOfReviews) ||
      Number(
        widget
          .closest('.pdp-reviews')
          ?.querySelector('.pdp-review-score span')
          ?.textContent.match(/\d+/)?.[0]
      ) ||
      list.querySelectorAll(':scope > .jdgm-rev').length;

    let visibleCount = Math.min(reviewInitialCount, totalCount);
    let apiPage = 0;
    let loading = false;
    let sortResetTimer;
    let sortFirstCard;

    if (!list.id) {
      list.id = `${widget.id || 'judgeme'}-visible-reviews`;
    }

    const controls = document.createElement('div');
    const loadMore = document.createElement('button');
    const loadMoreLabel = document.createElement('span');
    const showFewer = document.createElement('button');
    const status = document.createElement('span');

    controls.className = 'pdp-review-disclosure';
    controls.dataset.reviewDisclosure = '';

    loadMore.type = 'button';
    loadMore.className =
      'pdp-review-disclosure-button pdp-review-disclosure-button--more';
    loadMore.setAttribute('aria-controls', list.id);
    loadMoreLabel.textContent = 'load more reviews';
    loadMore.append(
      loadMoreLabel,
      createReviewDisclosureArrow()
    );

    showFewer.type = 'button';
    showFewer.className =
      'pdp-review-disclosure-button pdp-review-disclosure-button--fewer';
    showFewer.setAttribute('aria-controls', list.id);
    showFewer.textContent = 'show fewer reviews';

    status.className = 'pdp-review-disclosure-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');

    controls.append(loadMore, showFewer, status);

    const placeControls = () => {
      const body = widget.querySelector('.jdgm-rev-widg__body');

      if (body && controls.previousElementSibling !== body) {
        body.insertAdjacentElement('afterend', controls);
      }
    };

    const getCards = () => [
      ...list.querySelectorAll(':scope > .jdgm-rev'),
    ];

    const readTotal = () => {
      const nextRoot = widget.querySelector('.jdgm-rev-widg');

      return (
        Number(nextRoot?.dataset.numberOfReviews) ||
        Number(
          widget
            .closest('.pdp-reviews')
            ?.querySelector('.pdp-review-score span')
            ?.textContent.match(/\d+/)?.[0]
        ) ||
        getCards().length
      );
    };

    const render = () => {
      const cards = getCards();

      cards.forEach((card, index) => {
        card.hidden = index >= visibleCount;
      });

      widget.dataset.reviewDisclosureReady = '';

      loadMore.hidden = visibleCount >= totalCount;
      loadMore.setAttribute(
        'aria-expanded',
        String(visibleCount > reviewInitialCount)
      );

      showFewer.hidden = visibleCount <= reviewInitialCount;
      controls.hidden = totalCount <= reviewInitialCount;

      status.textContent = `${Math.min(
        visibleCount,
        totalCount
      )} of ${totalCount} reviews shown`;
    };

    const getSort = () => {
      const selected =
        widget.querySelector('.jdgm-sort-dropdown')?.value ||
        'most-recent';

      return reviewSortMap[selected] || reviewSortMap['most-recent'];
    };

    const fetchReviewPage = async () => {
      const endpoint = pagination?.dataset.url;
      const productId =
        widget.dataset.productId || widget.dataset.id;

      if (!endpoint || !productId) {
        throw new Error(
          'Judge.me review endpoint is unavailable.'
        );
      }

      const url = new URL(endpoint, window.location.href);

      if (!/(^|\.)judge\.me$/i.test(url.hostname)) {
        throw new Error('Unexpected review endpoint.');
      }

      const [sortBy, sortDirection] = getSort();
      const nextPage = apiPage + 1;
      const shopDomain =
        window.Shopify?.shop || window.location.hostname;

      url.searchParams.set('shop_domain', shopDomain);
      url.searchParams.set('url', shopDomain);
      url.searchParams.set('platform', 'shopify');
      url.searchParams.set('product_id', productId);
      url.searchParams.set('page', String(nextPage));
      url.searchParams.set(
        'per_page',
        String(reviewApiPageSize)
      );
      url.searchParams.set('sort_by', sortBy);

      if (sortDirection) {
        url.searchParams.set('sort_dir', sortDirection);
      }

      const response = await fetch(url, {
        headers: {
          Accept: 'application/json',
        },
        credentials: 'omit',
      });

      if (!response.ok) {
        throw new Error(
          `Reviews could not be loaded: ${response.status}`
        );
      }

      const data = await response.json();
      const parsed = new DOMParser().parseFromString(
        data.html || '',
        'text/html'
      );

      const fetchedCards = [
        ...parsed.querySelectorAll(
          '.jdgm-rev-widg__reviews > .jdgm-rev'
        ),
      ].map(normaliseReviewCard);

      if (
        !fetchedCards.length &&
        Number(data.total_count) > 0
      ) {
        throw new Error(
          'Judge.me returned no review cards.'
        );
      }

      totalCount = Number(data.total_count) || totalCount;

      if (nextPage === 1) {
        list.replaceChildren(...fetchedCards);
      } else {
        const existingIds = new Set(
          getCards()
            .map((card) => card.dataset.reviewId)
            .filter(Boolean)
        );

        fetchedCards.forEach((card) => {
          const reviewId = card.dataset.reviewId;

          if (!reviewId || !existingIds.has(reviewId)) {
            list.append(card);
          }
        });
      }

      apiPage = nextPage;
      getCards().forEach(normaliseReviewCard);
    };

    const useNativePagination = () => {
      widget.removeAttribute(
        'data-review-disclosure-ready'
      );

      controls.hidden = true;

      getCards().forEach((card) => {
        card.hidden = false;
      });

      pagination?.removeAttribute('hidden');
      pagination?.style.removeProperty('display');
    };

    loadMore.addEventListener('click', async () => {
      if (loading) return;

      const targetCount = Math.min(
        visibleCount + reviewBatchSize,
        totalCount
      );

      loading = true;
      loadMore.disabled = true;
      loadMore.setAttribute('aria-busy', 'true');
      loadMoreLabel.textContent = 'loading reviews';

      try {
        if (
          apiPage === 0 ||
          targetCount > getCards().length
        ) {
          await fetchReviewPage();
        }

        visibleCount = Math.min(
          targetCount,
          getCards().length
        );

        render();
      } catch (error) {
        console.error(error);
        status.textContent =
          'More reviews could not be loaded.';
        useNativePagination();
      } finally {
        loading = false;
        loadMore.disabled = false;
        loadMore.removeAttribute('aria-busy');
        loadMoreLabel.textContent = 'load more reviews';
      }
    });

    showFewer.addEventListener('click', () => {
      const before =
        controls.getBoundingClientRect().top;

      visibleCount = Math.min(
        reviewInitialCount,
        totalCount
      );

      render();

      const after =
        controls.getBoundingClientRect().top;

      window.scrollBy({
        top: after - before,
        left: 0,
        behavior: 'auto',
      });

      loadMore.focus({ preventScroll: true });
    });

    const sortObserver = new MutationObserver(() => {
      if (!sortResetTimer) return;

      const nextList = widget.querySelector(
        '.jdgm-rev-widg__reviews'
      );

      if (
        !nextList ||
        (
          nextList === list &&
          nextList.querySelector(
            ':scope > .jdgm-rev'
          ) === sortFirstCard
        )
      ) {
        return;
      }

      window.clearTimeout(sortResetTimer);

      sortResetTimer = window.setTimeout(() => {
        const nextPagination =
          widget.querySelector('.jdgm-paginate');

        if (!nextList || !nextPagination) return;

        list = nextList;
        pagination = nextPagination;
        totalCount = readTotal();
        visibleCount = Math.min(
          reviewInitialCount,
          totalCount
        );
        apiPage = 0;

        if (!list.id) {
          list.id =
            `${widget.id || 'judgeme'}-visible-reviews`;
        }

        loadMore.setAttribute(
          'aria-controls',
          list.id
        );

        showFewer.setAttribute(
          'aria-controls',
          list.id
        );

        placeControls();
        render();

        sortResetTimer = undefined;
        sortFirstCard = undefined;
      }, 120);
    });

    sortObserver.observe(widget, {
      childList: true,
      subtree: true,
    });

    widget.addEventListener('change', (event) => {
      if (
        !(event.target instanceof Element) ||
        !event.target.matches('.jdgm-sort-dropdown')
      ) {
        return;
      }

      sortFirstCard = getCards()[0];

      sortResetTimer = window.setTimeout(() => {
        sortResetTimer = undefined;
        sortFirstCard = undefined;
      }, 8000);
    });

    placeControls();
    render();

    reviewDisclosureControllers.set(widget, true);
  };

  const initialiseReviewDisclosures = () => {
    document
      .querySelectorAll(
        '.pdp-reviews #judgeme_product_reviews.jdgm--done-setup-widget'
      )
      .forEach(initialiseReviewDisclosure);
  };

  initialiseReviewDisclosures();

  document
    .querySelectorAll('[data-review-grid]')
    .forEach((grid) => {
      const observer = new MutationObserver(
        initialiseReviewDisclosures
      );

      observer.observe(grid, {
        childList: true,
        subtree: true,
      });
    });


  const reviewDisclosureObservers = new WeakSet();
  let reviewDisclosureId = 0;

  const enhanceLongReview = (reviewBody) => {
    const reviewCard = reviewBody.closest('.jdgm-rev');

    if (!reviewCard) return;

    /*
     * Keep one existing disclosure and remove any duplicates
     * created during a Judge.me refresh.
     */
    const existingControls = [
      ...reviewCard.querySelectorAll(
        '.inlet-review-disclosure'
      ),
    ];

    if (existingControls.length) {
      existingControls
        .slice(1)
        .forEach((control) => control.remove());

      reviewBody.dataset.inletReviewDisclosure =
        'ready';

      return;
    }

    const disclosureState =
      reviewBody.dataset.inletReviewDisclosure;

    if (
      disclosureState === 'measuring' ||
      disclosureState === 'short'
    ) {
      return;
    }

    /*
     * Mark this review before measuring it so simultaneous
     * Judge.me mutations cannot schedule another button.
     */
    reviewBody.dataset.inletReviewDisclosure =
      'measuring';

    /*
     * Remove Judge.me's own truncated state before applying
     * the Inlet disclosure.
     */
    try {
      window.jdgm
        ?.$?.(reviewBody)
        ?.trigger?.('destroy.dot');
    } catch (error) {
      /* Judge.me may not have finished loading yet. */
    }

    reviewCard
      .querySelectorAll(
        '.jdgm-rev__body-read-more'
      )
      .forEach((control) => control.remove());

    reviewBody.classList.add(
      'inlet-review-copy--collapsed'
    );

    reviewBody.classList.remove(
      'inlet-review-copy--expanded'
    );

    const measureReview = (attempt = 0) => {
      if (!reviewBody.isConnected) return;

      if (
        reviewBody.getBoundingClientRect().width === 0
      ) {
        if (attempt < 8) {
          window.setTimeout(
            () => measureReview(attempt + 1),
            80
          );
        } else {
          delete reviewBody.dataset
            .inletReviewDisclosure;
        }

        return;
      }

      const needsDisclosure =
        reviewBody.scrollHeight >
        reviewBody.clientHeight + 2;

      if (!needsDisclosure) {
        reviewBody.classList.remove(
          'inlet-review-copy--collapsed'
        );

        reviewBody.dataset.inletReviewDisclosure =
          'short';

        return;
      }

      /*
       * Check again after measuring in case another process
       * completed first.
       */
      const existingControl =
        reviewCard.querySelector(
          '.inlet-review-disclosure'
        );

      if (existingControl) {
        reviewBody.dataset.inletReviewDisclosure =
          'ready';

        return;
      }

      if (!reviewBody.id) {
        reviewDisclosureId += 1;

        reviewBody.id =
          `InletReviewBody${reviewDisclosureId}`;
      }

      const button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'inlet-review-disclosure pdp-write-review-link';

      button.textContent = 'read full review';

      button.setAttribute(
        'aria-expanded',
        'false'
      );

      button.setAttribute(
        'aria-controls',
        reviewBody.id
      );

      reviewBody.insertAdjacentElement(
        'afterend',
        button
      );

      reviewBody.dataset.inletReviewDisclosure =
        'ready';

      button.addEventListener('click', () => {
        const willExpand =
          button.getAttribute('aria-expanded') !==
          'true';

        const buttonPosition =
          button.getBoundingClientRect().top;

        reviewBody.classList.toggle(
          'inlet-review-copy--collapsed',
          !willExpand
        );

        reviewBody.classList.toggle(
          'inlet-review-copy--expanded',
          willExpand
        );

        reviewCard.classList.toggle(
          'inlet-review-card--expanded',
          willExpand
        );

        button.setAttribute(
          'aria-expanded',
          String(willExpand)
        );

        button.textContent = willExpand
          ? 'show less'
          : 'read full review';


        if (!willExpand) {
          const positionChange =
            button.getBoundingClientRect().top -
            buttonPosition;

          window.scrollBy(0, positionChange);

          button.focus({
            preventScroll: true,
          });
        }
      });
    };

    window.requestAnimationFrame(() => {
      measureReview();
    });
  };

  const initialiseLongReviews = (section) => {
    section
      .querySelectorAll('.jdgm-rev__body')
      .forEach(enhanceLongReview);
  };

  const observeLongReviews = (section) => {
    if (reviewDisclosureObservers.has(section)) {
      return;
    }

    initialiseLongReviews(section);

    const observer = new MutationObserver(() => {
      initialiseLongReviews(section);
    });

    observer.observe(section, {
      childList: true,
      subtree: true,
    });

    reviewDisclosureObservers.add(section);
  };

  document
    .querySelectorAll('.pdp-reviews')
    .forEach(observeLongReviews);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const visibleForm = [
        ...document.querySelectorAll(
          `.pdp-reviews ${reviewFormSelector}`
        ),
      ].find(reviewFormIsVisible);

      if (visibleForm) {
        const context = getReviewContext(visibleForm);

        if (context) {
          event.preventDefault();
          closeReviewForm(context);
          return;
        }
      }

      if (searchPanel && !searchPanel.hidden) {
        setSearch(false);
      }
    }
  });
})();
